<template>
  <!--srcviewscompanylistriskvuehtmlStart-->
  <div>
    <div v-show="CompanyQuestionShow" class="modal-overlay">
      <CompanyQuestion
        ref="CompanyQuestion"
        class="modal-container"
        v-show="CompanyQuestionShow"
        :CompanyQuestionShow="CompanyQuestionShow"
        @getPantentList="getPantentList($event)"
        @refreshCompanyList="onRefreshCompanyList"
      ></CompanyQuestion>
    </div>
    <div id="defaultId1" class="leads_cont">
      <div
        v-loading="RiskLoding"
        :class="[
          'leads_cont_left',
          $store.state.app.isMenu ? '' : 'hidemenu',
          !Compare ? '' : 'vague',
        ]"
      >
        <div class="left_menu-headbox" v-if="isShowfilterTab">
          <ul class="flex_center_bettwen flilterClass margin-bottom20">
            <li
              v-for="(item, index) in FilterList"
              :class="index == FilterIndex ? 'yellow' : 'yellownone'"
              :key="index"
              @click="FilterChange(index)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div
          :class="{
            left_menu_content: isShowfilterTab,
            left_menu_content_all: !isShowfilterTab,
          }"
        >
          <div class="left_menu">
            <div v-if="FilterIndex == 0">
              <el-collapse v-model="filterMenu" class="filter_first_box">
                <el-collapse-item title="" name="1" class="filter_first_item">
                  <template slot="title">
                    <span class="left_menu_filter">
                      {{ $t("Toolbar.Filter") }} ({{ leadScoreType.length }})
                      <i class="iconfont icon-lujing fiter_ic"></i>
                    </span>
                    <span class="clear_all" @click.stop="clearFiltersParams">
                      <i class="iconfont icon-qingchu"></i
                      >{{ $t("ListofResults.ClearAll") }}
                    </span>
                  </template>
                  <div class="filter_first_checkbox">
                    <el-checkbox
                      :indeterminate="filterIndeterminate"
                      v-model="filterCheckAll"
                      @change="onFilterCheckAll"
                      >{{ $t("Toolbar.ALL") }}</el-checkbox
                    >
                    <el-checkbox-group
                      fill="#8E86DD"
                      v-model="leadScoreType"
                      @change="(val) => onChangeParams(val)"
                    >
                      <el-checkbox
                        :label="ops.code"
                        v-for="(ops, index) in filterList"
                        :key="index"
                      >
                        <span class="check_label">
                          <OverflowTooltip :tip="ops.questionContent" />
                        </span>
                      </el-checkbox>
                    </el-checkbox-group>
                    <el-button
                      class="filter_first_btn btn_exportCollect"
                      @click="confirmFilter"
                      >{{ $t("ListofResults.Confirm") }}</el-button
                    >
                  </div>
                </el-collapse-item>
              </el-collapse>

              <el-collapse v-model="filterOpenMenu" class="FilterQuestion">
                <!-- 暂无功能  @changeRuler="onChangeLeadScRuler"-->
                <el-collapse-item
                  :title="$t('SearchLeadsList.LeadScore')"
                  name="19"
                >
                  <DiscreteSlider v-model="percentLeadScore" />
                </el-collapse-item>
                <el-collapse-item
                  :title="$t('SearchLeadsList.AccuracyScale')"
                  name="20"
                >
                  <DiscreteSlider v-model="percentAccuracyScale" />
                  <!-- @changeRuler="onChangeAccuracyScRuler" -->
                </el-collapse-item>

                <template v-if="ComanyFilterList.length > 0">
                  <el-collapse-item
                    v-for="(ite, ind) in ComanyFilterList"
                    :key="ind"
                    :title="ite.leadsQuestions?.questionContent || ''"
                    :name="ind"
                  >
                    <div v-if="ite.leadsQuestions.type == 10">
                      <div class="coll_child">
                        <el-checkbox-group
                          v-model="ite.selectedCodes"
                          @change="menuCheck()"
                        >
                          <el-checkbox
                            v-for="(child, i) in ite.leadsOptions"
                            :key="i"
                            v-model="child.pid"
                            :label="child.optionsCode"
                          >
                            <span class="check_label">
                              <OverflowTooltip :tip="child.optionsContent" />
                            </span>
                          </el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </el-collapse-item>
                </template>
              </el-collapse>
            </div>

            <div v-if="FilterIndex == 1">
              <div class="left_menu_clear flex_box">
                <h2 class="left_menu_title font_color">
                  {{ $store.state.app.SeachLabelsCodeName }}
                </h2>
                <span class="clear_all" @click.stop="clearFiltersParams">
                  <i class="iconfont icon-qingchu"></i
                  >{{ $t("SearchLeadsContact.ClearAll") }}
                </span>
              </div>
              <el-collapse v-model="filterOpenQuesMenu">
                <el-collapse-item
                  :name="index"
                  v-for="(item, index) in CompanyQuestionList"
                  v-if="item.selectedCodes != null"
                >
                  <template slot="title">
                    <OverflowTooltip
                      class="font_bold"
                      :tip="item.leadsQuestions.questionContent"
                    />
                  </template>
                  <div class="margin-bottom20 question_box">
                    <!-- <div v-if="item.leadsQuestions.type == 1">
                      <el-cascader
                        v-model="item.selectedCodes.id"
                        style="width: 100%"
                        :disabled="true"
                        filterable
                        :popper-append-to-body="false"
                        :props="cascaderProps"
                        :options="item.leadsOptions"
                        placeholder="Please select Please choose your role"
                        ref="cascader"
                      >
                      </el-cascader>
                    </div> -->
                    <div v-if="item.leadsQuestions.type == 2">
                      <el-select
                        filterable
                        style="width: 100%"
                        :popper-append-to-body="false"
                        :disabled="true"
                        value-key="optionsCode"
                        v-model="item.selectedCodes"
                        :placeholder="item.leadsQuestions?.questionContent"
                      >
                        <el-option
                          v-for="ite in item.leadsOptions"
                          :key="ite.optionsCode"
                          :label="ite.optionsContent"
                          :value="ite"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div
                      v-if="
                        item.leadsQuestions.type == 3 &&
                        item.selectedCodes.length > 0
                      "
                    >
                      <el-select
                        style="width: 100%"
                        filterable
                        value-key="optionsCode"
                        :multiple="true"
                        v-model="item.selectedCodes"
                        :placeholder="item.leadsQuestions.questionContent"
                        @remove-tag="
                          (val) =>
                            (Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.length > 1) ||
                            (item.selectedCodes?.optionsContent &&
                              Array.isArray(
                                item.selectedCodes.optionsContent,
                              ) &&
                              item.selectedCodes.optionsContent.length > 1)
                              ? handleRemoveTag(val, item)
                              : null
                        "
                        @change="menuQuesChange()"
                      >
                        <el-option
                          v-for="ite in item.leadsOptions"
                          :key="ite.optionsCode"
                          :label="ite.optionsContent"
                          :value="ite"
                          :disabled="
                            ((Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.length === 1) ||
                              (item.selectedCodes?.optionsContent &&
                                Array.isArray(
                                  item.selectedCodes.optionsContent,
                                ) &&
                                item.selectedCodes.optionsContent.length ===
                                  1)) &&
                            ((Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.some(
                                (option) =>
                                  option.optionsCode === ite.optionsCode,
                              )) ||
                              (item.selectedCodes?.optionsContent &&
                                Array.isArray(
                                  item.selectedCodes.optionsContent,
                                )))
                          "
                        >
                          <OverflowTooltip
                            :tip="ite.optionsContent"
                            class="check_label"
                          />
                        </el-option>
                      </el-select>
                    </div>
                    <div v-if="item.leadsQuestions.type == 5">
                      <div style="display: flex" class="margin-bottom10">
                        <el-radio
                          v-model="item.selectedOptions"
                          label="Yes"
                          border
                          @change="handleRadioChange(item, 'Yes')"
                          >Yes</el-radio
                        >
                        <el-radio
                          v-model="item.selectedOptions"
                          label="No"
                          border
                          @change="handleRadioChange(item, 'No')"
                          >No</el-radio
                        >
                      </div>
                      <el-input
                        v-if="item.selectedOptions == 'Yes'"
                        v-model="item.selectedCodes"
                        :placeholder="item.leadsQuestions.questionContent"
                        @input="menuQuesChange()"
                      >
                      </el-input>
                    </div>
                    <div
                      v-if="item.leadsQuestions.type == 8"
                      style="position: relative"
                    >
                      <!-- <el-input
                        v-model="item.selectedCodes.optionsContent"
                        :placeholder="item.leadsQuestions.questionContent"
                      >
                      </el-input> -->
                      <el-select
                        filterable
                        style="width: 100%"
                        :popper-append-to-body="true"
                        :loading="loading"
                        value-key="optionsCode"
                        loading-text=""
                        :no-data-text="''"
                        no-match-text=""
                        v-model="item.selectedCodes.optionsContent"
                        remote
                        :remote-method="debouncedRemoteMethod"
                        :placeholder="item.leadsQuestions.questionContent"
                        @remove-tag="
                          (val) =>
                            (Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.length > 1) ||
                            (item.selectedCodes?.optionsContent &&
                              Array.isArray(
                                item.selectedCodes.optionsContent,
                              ) &&
                              item.selectedCodes.optionsContent.length > 1)
                              ? handleRemoveTag(val, item)
                              : null
                        "
                        @change="menuQuesChange()"
                      >
                        <el-option
                          v-for="ite in item.leadsOptions"
                          :loading="loading"
                          :key="ite.id"
                          :label="ite.optionsContent"
                          :value="ite"
                          :disabled="
                            ((Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.length === 1) ||
                              (item.selectedCodes?.optionsContent &&
                                Array.isArray(
                                  item.selectedCodes.optionsContent,
                                ) &&
                                item.selectedCodes.optionsContent.length ===
                                  1)) &&
                            ((Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.some(
                                (option) => option.id === ite.id,
                              )) ||
                              (item.selectedCodes?.optionsContent &&
                                Array.isArray(
                                  item.selectedCodes.optionsContent,
                                )))
                          "
                        >
                          <el-tooltip
                            :disabled="ite.optionsContent.length < 65"
                            effect="light"
                            :content="ite.optionsContent"
                            :visible-arrow="false"
                            placement="top"
                          >
                            <span v-html="highlightKeyword(ite.optionsContent)">
                            </span>
                          </el-tooltip>
                        </el-option>
                      </el-select>
                      <i
                        style="cursor: pointer"
                        class="el-saech-eye el-input__icon el-icon-search"
                      ></i>
                    </div>
                    <div v-if="item.leadsQuestions.type == 7">
                      <el-input
                        v-model="item.selectedCodes"
                        :placeholder="item.leadsQuestions.questionContent"
                        @change="menuQuesChange()"
                      >
                      </el-input>
                    </div>
                    <div
                      v-if="item.leadsQuestions.type == 9"
                      style="position: relative"
                    >
                      <!-- <el-select
                        style="width: 100%"
                        :popper-append-to-body="false"
                        ref="upSelectduoxuanSearch"
                        value-key="aaa_id"
                        v-model="item.selectedCodes"
                        :multiple="true"
                        :placeholder="item.leadsQuestions.questionContent"
                      >
                        <el-option
                          v-for="ite in item.leadsOptions"
                          :key="ite.aaa_id"
                          :label="ite.optionsContent"
                          :value="ite"
                        >
                          <div class="flex_center_start_box Search_Company">
                            <img class="Country_img" :src="ite.flag" /><span
                              class="Country_name"
                              >{{ ite.optionsContent }}</span
                            >
                          </div>
                        </el-option>
                      </el-select> -->

                      <el-select
                        filterable
                        :loading="loading"
                        style="width: 100%"
                        :popper-append-to-body="true"
                        ref="upSelectduoxuanSearch"
                        value-key="aaa_id"
                        v-model="item.selectedCodes"
                        remote
                        :multiple="true"
                        :remote-method="
                          item.leadsQuestions.code == 6
                            ? debouncedRemoteMethodCompany
                            : debouncedRemoteMethodCompany3
                        "
                        :placeholder="item.leadsQuestions.questionContent"
                        @remove-tag="
                          (val) =>
                            (Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.length > 1) ||
                            (item.selectedCodes?.optionsContent &&
                              Array.isArray(
                                item.selectedCodes.optionsContent,
                              ) &&
                              item.selectedCodes.optionsContent.length > 1)
                              ? handleRemoveTag(val, item)
                              : null
                        "
                        @change="menuQuesChange()"
                      >
                        <el-option
                          v-for="ite in item.leadsOptions"
                          :key="ite.aaa_id"
                          :label="ite.optionsContent"
                          :value="ite"
                          :disabled="
                            ((Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.length === 1) ||
                              (item.selectedCodes?.optionsContent &&
                                Array.isArray(
                                  item.selectedCodes.optionsContent,
                                ) &&
                                item.selectedCodes.optionsContent.length ===
                                  1)) &&
                            ((Array.isArray(item.selectedCodes) &&
                              item.selectedCodes.some(
                                (option) => option.aaa_id === ite.aaa_id,
                              )) ||
                              (item.selectedCodes?.optionsContent &&
                                Array.isArray(
                                  item.selectedCodes.optionsContent,
                                )))
                          "
                        >
                          <div class="flex_center_start_box Search_Company">
                            <img class="Country_img" :src="ite.flag" /><span
                              class="Country_name"
                              >{{ ite.optionsContent }}</span
                            >
                          </div>
                        </el-option>
                      </el-select>
                      <i class="el-saech-eye el-input__icon el-icon-search"></i>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>

            <p class="left_menu_bottom">
              <!-- Does your company have any overseas companies? -->
            </p>
          </div>
        </div>
        <div
          class="AnswerbutoonBox left_menu_bottom_btn"
          v-if="isShowfilterTab"
        >
          <button
            :disabled="FilterIndex == 0"
            class="Answerbutoon"
            @click="SaveMyAnswer()"
          >
            {{ $t("LeadsAIAssistance.Savemyanswers") }}
          </button>
        </div>
      </div>

      <div
        id="cc5f49"
        :class="
          $store.state.app.isMenu
            ? 'scrollbar scrollbar_risk_right'
            : ' scrollbar scrollbar_risk_right left_no_menu'
        "
        v-show="!CompanyQuestionShow"
      >
        <div style="height: 100%">
          <div class="list-label" v-show="!Compare">
            <div
              id="c6d65e"
              class="leads_right_top_num Alchecked flex_between_box"
            >
              <div>
                <el-checkbox
                  v-if="isOpenSlct"
                  class="margin-right20"
                  id="c0b733"
                  v-model="checked"
                  label
                  :indeterminate="indeterminateLeads"
                  @change="changeSlctAll"
                  >{{ $t("Toolbar.ALL") }}</el-checkbox
                >
                {{ $t("SearchLeadsList.Foundover") }}
                <span class="foundOverNum">{{
                  CompanyList?.slice(0, 20).length
                }}</span>
                <span v-if="this.$route.query.initialKeyword">
                  "
                  {{ this.$route.query.initialKeyword }}" results</span
                >
                <el-button
                  v-if="isOpenSlct"
                  class="margin-left20"
                  :class="
                    $store.state.app.collectList.length == 0 ||
                    $store.state.app.changeList.length == 0
                      ? ' btn_export leadsDialogD8850'
                      : 'btn_exportCollect'
                  "
                  :disabled="
                    $store.state.app.collectList.length == 0 ||
                    $store.state.app.changeList.length == 0
                  "
                  @click="CollectCheckBook"
                  >{{ $t("ListofResults.Confirm") }}</el-button
                >
              </div>
              <div class="flex_center">
                <div
                  @click="getleadsPostFilterchangeSearch"
                  v-if="
                    CompanyListRandom.length > 0 &&
                    !['MF1003', 'TC1003', 'SC1003'].includes(
                      leadsListModuleCode,
                    )
                  "
                >
                  <span class="huanyipi flex_center_bettwen">
                    <i class="iconfont icon-icon_gengxin"></i>
                    <span class="margin-left5" @click="getSearchListTypecode">{{
                      $t("SearchLeadsList.Changeseach")
                    }}</span>
                  </span>
                </div>
                <div @click="ChangeIt">
                  <span
                    v-if="riskTotal > 20"
                    class="huanyipi flex_center_bettwen margin-left30"
                  >
                    <i class="iconfont icon-icon_gengxin"></i>
                    <span class="margin-left5">{{
                      $t("SearchLeadsList.Refreshformore")
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="flex_center_between_box risk-center-list-box"
              v-loading="RiskLoding"
            >
              <div
                class="risk-center-list"
                :style="{ overflowY: NationalIndustryShow ? 'hidden' : 'auto' }"
              >
                <div>
                  <ul>
                    <draggable
                      filter=".forbid"
                      v-model="CompanyList"
                      :disabled="disabled"
                      animation="300"
                      :move="onMove"
                    >
                      <transition-group>
                        <li
                          v-for="(item, index) in CompanyList?.slice(0, 20)"
                          :key="index"
                          :class="[
                            item.isDing
                              ? 'conpany-center-list forbid item'
                              : 'conpany-center-list item',
                            { iconbgActiveBG: NationalIndustryActive == index },
                          ]"
                          style="position: relative"
                        >
                          <div class="flex_between_box">
                            <div class="conpany-center-list-left">
                              <el-checkbox
                                v-if="isOpenSlct"
                                id="cee084"
                                class="margin-right10"
                                v-model="item.isChecked"
                                label
                                @change="changeItemChecked"
                              >
                              </el-checkbox>
                              <span
                                class="margin-right20"
                                :class="
                                  item.isDing
                                    ? 'indexPositon'
                                    : 'indexPositonactive'
                                "
                                >{{ index + 1 }}</span
                              >
                              <div>
                                <p>
                                  <span
                                    @click="setNews(item, 'prife')"
                                    style="cursor: pointer"
                                    class="font_bold"
                                    >{{ item.company_name_en }}</span
                                  >
                                  <!-- <el-popover  placement="top" trigger="hover"  popper-class="Risk-list-popover"
                                                                    content="Verified">
                                                                    <span slot="reference"  class="margin-left20">
                                                                        
                                                                        <svg t="1733197205750"
                                                                            class="icon" viewBox="0 0 1024 1024"
                                                                            version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            p-id="6215" width="1.7142857142857142rem"
                                                                            height="1.7142857142857142rem">
                                                                            <path
                                                                                d="M445.7472 959.0784a66.88768 66.88768 0 0 1-99.90144-26.76736 113.74592 113.74592 0 0 0-114.76992-66.2528 66.88768 66.88768 0 0 1-73.1136-73.13408 113.74592 113.74592 0 0 0-66.27328-114.76992 66.88768 66.88768 0 0 1-26.76736-99.90144 113.74592 113.74592 0 0 0 0-132.5056 66.88768 66.88768 0 0 1 26.76736-99.90144 113.74592 113.74592 0 0 0 66.2528-114.76992 66.88768 66.88768 0 0 1 73.13408-73.1136 113.74592 113.74592 0 0 0 114.76992-66.27328 66.88768 66.88768 0 0 1 99.90144-26.76736 113.74592 113.74592 0 0 0 132.5056 0 66.88768 66.88768 0 0 1 99.90144 26.76736 113.74592 113.74592 0 0 0 114.76992 66.2528 66.88768 66.88768 0 0 1 73.1136 73.13408 113.74592 113.74592 0 0 0 66.27328 114.76992 66.88768 66.88768 0 0 1 26.76736 99.90144 113.74592 113.74592 0 0 0 0 132.5056 66.88768 66.88768 0 0 1-26.76736 99.90144 113.74592 113.74592 0 0 0-66.2528 114.76992 66.88768 66.88768 0 0 1-73.13408 73.1136 113.74592 113.74592 0 0 0-114.76992 66.27328 66.88768 66.88768 0 0 1-99.90144 26.76736 113.74592 113.74592 0 0 0-132.5056 0z"
                                                                                fill="#55B419" p-id="6216"
                                                                                data-spm-anchor-id="a313x.manage_type_myprojects.0.i4.36203a81GdIWQo"
                                                                                class="selected"></path>
                                                                            <path
                                                                                d="M416.58368 368.64v12.75904c-3.3792 0-6.63552 0.8192-9.78944 2.47808-3.13344 1.65888-4.7104 4.85376-4.7104 9.58464 0 5.20192 2.048 11.81696 6.16448 19.8656l6.79936 13.45536 8.06912 16.30208 92.8768 195.01056 90.68544-192.16384c4.64896-9.8304 9.05216-18.8416 13.23008-27.01312l3.09248-5.95968c5.07904-9.68704 7.61856-16.42496 7.61856-20.21376 0-6.9632-5.75488-10.73152-17.3056-11.264l-3.01056-0.08192V368.64H737.28v12.75904c-9.66656 0-16.6912 3.44064-21.03296 10.28096a172.032 172.032 0 0 0-8.13056 13.96736l-133.67296 287.45728A40.96 40.96 0 0 1 537.31328 716.8h-46.42816a40.96 40.96 0 0 1-37.0688-23.53152l-138.07616-293.43744a23.77728 23.77728 0 0 0-10.15808-11.34592 85.66784 85.66784 0 0 0-14.90944-5.89824L286.72 381.39904V368.64h129.86368z"
                                                                                fill="#FFFFFF" p-id="6217"
                                                                                data-spm-anchor-id="a313x.manage_type_myprojects.0.i5.36203a81GdIWQo"
                                                                                class=""></path>
                                                                        </svg>
                                                                    </span>
                                                                        </el-popover> -->
                                  <span class="margin-left20">
                                    <i
                                      class="icon iconfont icon-xingzhuangjiehe1"
                                      style="color: #ccc"
                                    ></i>
                                  </span>
                                  <span class="margin-left20">
                                    <i
                                      class="icon iconfont icon-shoucang"
                                      :style="{
                                        color: item.isFavorite
                                          ? '#F56B6B'
                                          : '#CCCCCC',
                                      }"
                                    ></i>
                                  </span>
                                  <!-- <span class="margin-left20">
                                    <i
                                      class="iconfont icon-a-lujingbeifen251 icontransform" 
                                      :class="{ rotate: item.isRotated }"
                                      @click="!NationalIndustryShow && getCompanyDetailList(item, index)"
                                    ></i>
                                  </span> -->
                                </p>

                                <p
                                  class="list-text-color"
                                  style="color: #29445d !important"
                                >
                                  <img :src="item.flag" />{{
                                    item.company_country
                                  }}
                                </p>
                                <p
                                  v-if="item.company_country == 'CN'"
                                  class="list-text-color"
                                >
                                  {{ $t("SearchLeadsList.CompanyNumber") }}:
                                  <OverflowTooltip :tip="item.usc_code" />
                                </p>
                                <p v-else class="list-text-color">
                                  {{ $t("SearchLeadsList.CompanyNumber") }}:
                                  <OverflowTooltip
                                    :tip="
                                      item.reg_number == '' ||
                                      item.reg_number == null
                                        ? item.usc_code
                                        : item.reg_number
                                    "
                                  />
                                </p>
                                <p class="list-text-color">
                                  {{ $t("SearchLeadsList.Address") }}:<span>
                                    {{ item.street_en }}
                                    <span
                                      style="margin-left: 0px"
                                      v-show="
                                        item.street_en &&
                                        item.street_en != ' ' &&
                                        item.street_en != '' &&
                                        item.city_en != '' &&
                                        item.city_en != ' ' &&
                                        item.city_en
                                      "
                                      >,</span
                                    >
                                    {{ item.city_en }}
                                    <span
                                      style="margin-left: 0px"
                                      v-show="
                                        item.province_en &&
                                        item.province_en != ' ' &&
                                        item.province_en != '' &&
                                        item.city_en != '' &&
                                        item.city_en != ' ' &&
                                        item.city_en
                                      "
                                      >,
                                    </span>
                                    {{ item.province_en }}
                                  </span>
                                </p>
                                <!-- 功能添加，没字段 -->
                                <div class="leads_cont_progress_box flex_box">
                                  <div class="leads_cont_progress">
                                    <div class="list-text-color">
                                      {{ $t("SearchLeadsList.LeadScore") }}
                                    </div>
                                    <el-progress
                                      color="#8E86DD"
                                      :percentage="item.accuracyScale"
                                      class="leads_cont_progress_pre"
                                      text-color="#8e86dd"
                                    >
                                    </el-progress>
                                  </div>
                                  <div class="leads_cont_progress">
                                    <div class="list-text-color">
                                      {{ $t("SearchLeadsList.AccuracyScale") }}
                                    </div>
                                    <el-progress
                                      color="#F56B6B"
                                      :percentage="item.accuracyScale"
                                      class="leads_cont_progress_pre leads_cont_progress_pre_sc"
                                      text-color="#f56b6b"
                                    >
                                    </el-progress>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="conpany-center-list-right">
                              <p>
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="$t('SearchLeadsList.Lockinlist')"
                                >
                                  <span slot="reference">
                                    <i
                                      v-if="item.isDing"
                                      @click="CansoleClick(item, index)"
                                      class="iconfont icon-dingzi icontop"
                                      style="color: #8e86dd"
                                    ></i>
                                    <i
                                      v-else
                                      class="iconfont icon-pin icontop cur_pointer"
                                      @click="DingClick(item, index)"
                                      style="color: #8497ab"
                                    ></i>
                                  </span>
                                </el-popover>
                                <span class="margin-left20">
                                  <i
                                    class="iconfont icon-shanchu iconright cur_pointer"
                                    @click="DelClick(item, index)"
                                    style="color: #f56b6b"
                                  ></i>
                                </span>
                              </p>
                              <p class="con_cen_list_right_btn">
                                <!-- <download-excel
                                  id="c0b0a6"
                                  :fetch="DetailsFormConcat"
                                  :fields="json_fields"
                                  name="Company.xls"
                                >
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    popper-class="table_popover"
                                    content="Download Contacts"
                                  >-->
                                <span
                                  slot="reference"
                                  class="iconbg flex_center"
                                >
                                  <i
                                    class="iconfont icon-dianhuaheshi iconright"
                                    @click="exportCompanyWeb(item)"
                                    style="color: #ccc; cursor: Not-allowed"
                                  ></i>
                                </span>
                                <!--</el-popover>
                                </download-excel> -->

                                <!-- <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('SearchLeadsList.ContactInformation')
                                  "
                                >
                                  <span
                                    slot="reference"
                                    class="iconbg flex_center"
                                    @click="linktoContact(item)"
                                  >
                                    <i
                                      class="iconfont icon-dianhuaheshi iconright"
                                      :style="{
                                        color: item.aaa_id ? '#685ED1' : '#ccc',
                                      }"
                                    ></i>
                                  </span>
                                </el-popover> -->
                                <!-- <download-excel
                                  id="c0b0a6"
                                  :fetch="DetailsFormImport"
                                  :fields="json_fieldsImport"
                                  name="supply chain.xls"
                                > -->
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('SearchLeadsList.SupplyChainList')
                                  "
                                >
                                  <button
                                    slot="reference"
                                    :disabled="item.ieflag != '1'"
                                    class="margin-left20 iconbg flex_center"
                                    @click="exportCompanyImport(item)"
                                  >
                                    <i
                                      class="iconfont icon-gongyinglianyunyingnengli iconright"
                                      :style="{
                                        color:
                                          item.ieflag != '1'
                                            ? '#CCCCCC'
                                            : '#685ED1',
                                      }"
                                    ></i>
                                  </button>
                                </el-popover>
                                <!-- </download-excel> -->
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="$t('SearchLeadsList.IndustryInfo')"
                                >
                                  <span
                                    slot="reference"
                                    class="margin-left20 iconbg flex_center"
                                    :class="{
                                      iconbgActive:
                                        NationalIndustryActive == index,
                                    }"
                                  >
                                    <i
                                      class="iconfont icon-shujufenxi1 iconright"
                                      @click="NationalIndustry(item, index)"
                                      :style="{
                                        color:
                                          NationalIndustryActive == index
                                            ? '#FFFFFF'
                                            : '#685ED1',
                                      }"
                                    ></i>
                                  </span>
                                </el-popover>
                              </p>
                            </div>
                          </div>
                          <transition name="fade">
                            <div
                              class="flex_box bottom-list-echarts margin-top20 margin-left30"
                              v-show="item.isRotated"
                            >
                              <div class="bottom-list-echarts-li">
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchLeadsList.RegistrationDate')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t(
                                              "SearchLeadsList.RegistrationDate",
                                            )
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate
                                        "
                                        placement="top"
                                      >
                                        <span class="color1290C9">{{
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">{{
                                        $t("SearchLeadsList.Profit")
                                      }}</span>
                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.profit?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        "
                                        placement="top"
                                      >
                                        <span class="color1290C9">{{
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchLeadsList.NoofShareholders')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t(
                                              "SearchLeadsList.NoofShareholders",
                                            )
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <span class="color1290C9 line_1">{{
                                        item.prifeTeable?.current?.shareholds
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchLeadsList.TotalAssets')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchLeadsList.TotalAssets")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.asset?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.asset
                                        "
                                        placement="top"
                                      >
                                        <span class="color1290C9">{{
                                          item.prifeTeable?.financialStatus
                                            ?.asset
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchLeadsList.IndustryCode")
                                        }}</span
                                      >
                                      <span class="color1290C9 line_1">{{
                                        item.prifeTeable?.current?.industryCode
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchLeadsList.CreditRating")
                                        }}</span
                                      >
                                      <span class="color1290C9 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.creditRating
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchLeadsList.NoofEmployees')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchLeadsList.NoofEmployees")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <span class="color1290C9 line_1">{{
                                        item.prifeTeable?.current?.employee
                                          | FilterNum
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">{{
                                        $t("SearchLeadsList.CreditScore")
                                      }}</span>
                                      <span class="color1290C9 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.creditScore
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">{{
                                        $t("SearchLeadsList.Listed")
                                      }}</span>
                                      <span class="color1290C9 line_1">{{
                                        item.prifeTeable?.legalStatus?.listed
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchLeadsList.ESGRating")
                                        }}</span
                                      >
                                      <span class="color1290C9 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.ratingESG
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchLeadsList.Revenue")
                                        }}</span
                                      >
                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.profit?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        "
                                        placement="top"
                                      >
                                        <span class="color1290C9">{{
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchLeadsList.DQI") }}</span
                                      >
                                      <span class="color1290C9 line_1">{{
                                        item.prifeTeable?.creditRatings?.dqi
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  @click="setNews(item, 'prife')"
                                  class="MoreCompany margin-top20"
                                >
                                  {{ $t("SearchLeadsList.MoreCoDetails") }}
                                </div>
                              </div>
                              <div class="bottom-list-echarts-li">
                                <div
                                  ref="ImportEchart"
                                  style="width: 100%; height: 210px"
                                ></div>
                              </div>
                              <div class="bottom-list-echarts-li">
                                <p class="bottom-list-echarts-head">
                                  {{ $t("SearchLeadsList.CoNews") }}
                                </p>
                                <ul class="margin-bottom10">
                                  <li
                                    class="flex_center_between_box"
                                    v-for="(ite, index) in item.NewstableData"
                                    :key="index"
                                  >
                                    <el-tooltip
                                      class="item"
                                      effect="light"
                                      :visible-arrow="false"
                                      :content="ite.titleEn"
                                      placement="top"
                                      :disabled="ite.titleEn?.length < 35"
                                    >
                                      <div
                                        @click="setid(ite)"
                                        class="news-text"
                                      >
                                        {{ ite.titleEn }}
                                      </div>
                                    </el-tooltip>

                                    {{ ite.date }}
                                  </li>
                                </ul>
                                <div
                                  @click="setNews(item, 'news')"
                                  v-if="item.NewstableData?.length > 6"
                                  class="MoreCompany margin-top10"
                                >
                                  {{ $t("SearchLeadsList.MoreCoNews") }}
                                </div>
                              </div>
                            </div>
                          </transition>
                          <div
                            :class="{ 'margin-top20': item.isRotated }"
                            :style="{ height: item.isRotated ? '10px' : '0px' }"
                          ></div>
                          <i
                            class="iconfont icon-jiantouxia icon_sanjiaoLocation"
                            :class="{ rotate: item.isRotated }"
                            @click="
                              !NationalIndustryShow &&
                                getCompanyDetailList(item, index)
                            "
                          ></i>
                        </li>
                      </transition-group>
                    </draggable>
                  </ul>
                </div>
              </div>
              <div class="risk-right" v-if="NationalIndustryShow">
                <div class="risk_right_box_header">
                  <div class="flex_center_between_box">
                    <div class="risk_right_title font_bold">
                      {{ $t("SearchLeadsList.NationalIndustryData") }}
                    </div>
                    <div class="flex_center">
                      <span class="Upadetime"
                        >{{ $t("SearchLeadsList.LastUpdate") }}:
                        {{ LastUpdate }}</span
                      >
                      <i
                        class="iconfont icon-cuowu icon"
                        @click="rifghtUpdate()"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="risk_right_box">
                  <div class="risk-right-content">
                    <div class="risk-right-content-title">
                      {{ $t("SearchLeadsList.IndustryandCountryOverview") }}
                    </div>
                    <div class="flex_center_between_box">
                      <div class="left-txt">
                        {{ $t("SearchLeadsList.CountryName") }}
                      </div>
                      <div style="width: 50%" class="right-txt">
                        {{ CompanyObj?.countryName }}
                      </div>
                    </div>

                    <div class="flex_center_between_box margin-top20">
                      <div class="left-txt">
                        {{ $t("SearchLeadsList.BusinessEnvironment") }}
                      </div>
                      <div style="width: 50%" class="right-txt">
                        {{ CompanyObj?.businessEnvironment | FormatNum }}
                      </div>
                    </div>
                    <div class="flex_center_between_box margin-top20">
                      <div class="left-txt">
                        {{ $t("SearchLeadsList.LegalEnvironment") }}
                      </div>
                      <div style="width: 50%" class="right-txt">
                        {{ CompanyObj?.legalEnvironment | FormatNum }}
                      </div>
                    </div>
                    <div class="flex_center_between_box margin-top20">
                      <div class="left-txt">
                        {{ $t("SearchLeadsList.ConfidenceIndex") }}
                      </div>
                      <div style="width: 50%" class="right-txt">
                        {{ CompanyObj?.confidenceIndex | FormatNum }}
                      </div>
                    </div>
                    <div class="flex_center_between_box margin-top20">
                      <div class="left-txt">
                        {{ $t("SearchLeadsList.NationalCompetitivenessIndex") }}
                      </div>
                      <div style="width: 50%" class="right-txt">
                        {{
                          CompanyObj?.nationalCompetitivenessIndex | FormatNum
                        }}
                      </div>
                    </div>
                    <div class="flex_center_between_box margin-top20">
                      <div class="left-txt">
                        {{ $t("SearchLeadsList.NationalGDP") }}
                      </div>
                      <div style="width: 50%" class="right-txt">
                        {{ CompanyObj?.nationalGDP | FormatNum }}
                      </div>
                    </div>
                  </div>
                  <div class="risk-right-content">
                    <div class="risk-right-content-title">
                      {{
                        $t(
                          "SearchLeadsList.Industrysituationoftheaffiliatedcompany",
                        )
                      }}
                    </div>
                    <div class="flex_center_between_box">
                      <div class="left-txt">
                        {{
                          $t("SearchLeadsList.Subjectcompanyindustrydescripti")
                        }}
                      </div>
                      <div style="width: calc(100% - 220px)" class="right-txt">
                        {{ CompanyObj?.targetCompanyIndustryDescription }}
                      </div>
                    </div>

                    <div class="flex_center_between_box margin16">
                      <div class="left-txt">
                        {{ $t("SearchLeadsList.Targetenterpriseindustrycode") }}
                      </div>
                      <div style="width: 50%" class="right-txt">
                        {{ CompanyObj?.targetEnterpriseIndustryCode }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="risk-right-content"
                    v-if="CompanyObj?.industryScaleSegmentation?.length > 0"
                  >
                    <div class="risk-right-content-title">
                      {{ $t("SearchLeadsList.Industryscalesegmentation") }}
                    </div>
                    <el-table
                      empty-text="No Data"
                      :data="CompanyObj?.industryScaleSegmentation"
                      style="width: 100%"
                      row-class-name="highlight-row"
                      :cell-class-name="cellClassName"
                    >
                      <el-table-column label="" prop="desc">
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.desc
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('SearchLeadsList.Quantity')"
                        prop="data"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.data | FilterNum
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('SearchLeadsList.SubjectCompany')"
                        prop="sameIndustry"
                        show-overflow-tooltip
                        align="center"
                      >
                        <template slot-scope="scope">
                          <span class="table-content">
                            <i
                              v-if="scope.row.target == 'true'"
                              class="iconfont icon-2gou icon"
                              style="color: #55b419"
                            ></i>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div
                    class="risk-right-content"
                    v-if="CompanyObj?.industryYearSegmentation?.length > 0"
                  >
                    <div class="risk-right-content-title">
                      {{ $t("SearchLeadsList.Industryyearsegmentation") }}
                    </div>
                    <el-table
                      empty-text="No Data"
                      :data="CompanyObj?.industryYearSegmentation"
                      style="width: 100%"
                      row-class-name="highlight-row"
                      :cell-class-name="cellClassName"
                    >
                      <el-table-column
                        label=""
                        prop="desc"
                        width="340"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.desc
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('SearchLeadsList.Quantity')"
                        align="center"
                        prop="SubiectCompany"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.data | FilterNum
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('SearchLeadsList.SubjectCompany')"
                        prop="sameIndustry"
                        show-overflow-tooltip
                        align="center"
                      >
                        <template slot-scope="scope">
                          <span class="table-content">
                            <i
                              v-if="scope.row.target == 'true'"
                              class="iconfont icon-2gou icon"
                              style="color: #55b419"
                            ></i>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div
                    class="risk-right-content"
                    v-if="CompanyObj?.industryOperationSituation?.length > 0"
                  >
                    <div class="risk-right-content-title">
                      {{ $t("SearchLeadsList.Industryoperationsituation") }}
                    </div>
                    <el-table
                      empty-text="No Data"
                      :data="CompanyObj?.industryOperationSituation"
                      style="width: 100%"
                      row-class-name="highlight-row"
                      :cell-class-name="cellClassName"
                    >
                      <el-table-column
                        label=""
                        prop="desc"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.desc
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('SearchLeadsList.Quantity')"
                        align="center"
                        prop="SubiectCompany"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.data | FilterNum
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('SearchLeadsList.SubjectCompany')"
                        align="center"
                        prop="sameIndustry"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">
                            <i
                              v-if="scope.row.target == 'true'"
                              class="iconfont icon-2gou icon"
                              style="color: #55b419"
                            ></i>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="CompanyCompany right_cont_box" v-show="Compare">
            <compareCompanys
              :compareList="compareList"
              @CompareShowfalse="CompareShow($event)"
            >
            </compareCompanys>
          </div>
        </div>
      </div>
    </div>
    <QuestionExport
      :suoClose="ExportDialogSuo"
      @closeExportDialog="ExportDialog($event)"
    ></QuestionExport>
    <CompanyUpdate
      :suoClose="UpdateDialogSuo"
      @closeUpdateDialog="UpdateDialog($event)"
    ></CompanyUpdate>

    <QuestionSaved
      :suoClose="SavyeLeadsSuo"
      :Saved="Saved"
      @closeSaveDialog="SavedcloseDialog($event)"
    >
    </QuestionSaved>
    <el-dialog
      :visible.sync="deledeLaeadsDialog"
      center
      :close-on-click-modal="true"
      @close="deledeLaeadsDialog = false"
      custom-class="dialog_normalsuo dialog_normalpower"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center margin-bottom20">
            <img
              class="dialog_tip_img"
              src="../../../assets/dialogIcoImg/ExportTips.png"
              alt=""
            />
          </div>
          <h3 class="dialog_normal_question-head">
            {{ $t("SearchLeadsList.Tips") }}
          </h3>
          <div
            class="detail_cont_text margin-top20"
            style="padding: 0px; text-align: center"
          >
            {{ $t("SearchLeadsList.Areyousureyouwanttodeletethisdata") }}
          </div>
        </div>
      </div>
      <div class="flex_center margin-top30">
        <!-- <el-button
          class="btn_export leadsDialogD8850 riskButton"
          @click="deledeLaeadsDialog = false"
          >{{ $t("SearchLeadsContact.Cancel") }}</el-button
        > -->
        <el-button
          class="btn_export questionExportButtonactive riskButton margin-left30"
          @click="deLaeadsDialogubmit()"
          >OK</el-button
        >
      </div>
    </el-dialog>
    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <SupplyChainList
      :ContactObj="ContactInfo"
      :suoClose="SupplyChain"
      @clossuoDialogtwo="clossuoDialogtwo($event)"
      btnColor="rgb(142, 134, 221)"
      :PCM="PCMoudele"
    >
    </SupplyChainList>
  </div>
  <!--srcviewscompanylistriskvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import { formatNum } from "@/views/company/details/Background/utils";

import draggable from "vuedraggable";
import { findPartnerDetail } from "@/api/searchApi.js";
import CompanyQuestion from "./getCompany/CompanyQuestionTwo.vue";
import CompanyUpdate from "./getCompany/QuestionUpdate.vue";
import QuestionExport from "./getCompany/QuestionExport.vue";
import {
  addItems,
  getLeadsQuestions,
  getLeadsProductFilterList,
  getIndustryCodeFilterList,
  saveLeadsAnswers,
} from "@/api/userApi";
import { findPartnerPcnotDing } from "../../../api/searchApi";
import compareCompanys from "./compareCompanys";
import QuestionSaved from "./getCompany/QuestionSaved.vue";
import Login from "@/components/login.vue";
import DiscreteSlider from "./getCompany/CompanyDiscreteSlider.vue";
import SupplyChainList from "../../../../src/views/company/TradeProduct/SupplyChainList.vue";

import {
  getCompanyIndustryInfo,
  getCompanyDetail,
  getPdfLink,
  getsearchExport,
  getHuokePartPrivilege,
  searchMoreEmail,
  leadsPostFilter,
} from "@/api/companyApi.js";
import { searchCompany } from "@/api/searchApi.js";
import { mixins1 } from "@/mixins/index";
import { color } from "d3";
import { lab } from "d3";
export default {
  name: "",
  props: {},
  watch: {
    "$store.state.app.SeachLabels": {
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        // if(newVal!=''){
        // this.SearchLeadsSuo=false
        if (newVal) {
          this.chageItTrue = false;
          this.chageItIndex = 0;
          this.getSearchListType = 1;
          this.Compare = false;
          this.checked = false;
          this.compareList = [];
          this.$store.dispatch("app/setcollectList", []);
          this.$store.dispatch("app/setchangeList", this.compareList);
          this.setToolsAcive();
          this.NationalIndustryShow = false;
          this.NationalIndustryActive = undefined;
          this.RiskLoding = true;
          if (this.isNewQuestion) {
            this.$store.dispatch("app/SetSeachLabels", "");
            this.SaveMyAnswer();
          } else {
            this.labelsCode = newVal;
            this.leadsPostFilterList = null;

            this.findPartnerDetailList();

            this.isShowfilterTab = true;
          }
        }

        // this.page.pageNo = 1
        //   this.parentTable = []
        //   this.searchCompanyByName()
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },

    isOpenSlct: {
      handler(newVal, oldVal) {
        this.isOpenSlct = newVal;
        // 在这里处理columns属性的变化
        if (newVal == false) {
          this.checked = false;
          this.compareList = [];
          this.$store.dispatch("app/setcollectList", []);
          this.$store.dispatch("app/setchangeList", this.compareList);
          this.CompanyList.map((item) => {
            item.isChecked = false;
          });
          this.setToolsAcive();
        }

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    token: {
      handler(newVal, oldVal) {
        if (newVal) {
        } else {
          this.setToolsfalse();
        }
      },
      immediate: true,
    },
    Compare: {
      handler(newVal, oldVal) {
        this.Compare = newVal;
        if (this.Compare) {
          // this.setToolsfalse();
        } else {
          this.compareList.map((item) => {
            item.isChecked = false;
            this.setToolsAcive();
            this.indeterminateLeads = false;
          });
        }
        // 在这里处理columns属性的变化
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    ReSelectCriteria: {
      handler(newVal, oldVal) {
        this.chageItTrue = false;
        this.chageItIndex = 0;
        this.getSearchListType = 1;
        // this.$refs.CompanyQuestion.percentage = 25;
        // this.$refs.CompanyQuestion.$refs.carousel.setActiveItem(0);
        // this.$refs.CompanyQuestion.currentIndex = 0;
        if (oldVal != undefined) {
          // this.isNewQuestion=true
          this.SaveAnswer = false;
          this.leadsPostFilterList = [];
          this.NationalIndustryShow = false;
          this.NationalIndustryActive = undefined;
          this.$refs.CompanyQuestion.questionWentiDialog = true;
          this.$store.dispatch("app/SetSeachLabels", "");
          this.$refs.CompanyQuestion.SavedAnswerIndexActive = undefined;
          this.isNewQuestion = false;
          // this.$store.commit("setRefreshKey", new Date().getTime());
          this.CompanyQuestionShow = true;
        }
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Saved: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.Saved = newVal;
          this.SavyeLeadsSuo = true;

          this.CompanyQuestionShow = false;
        }

        // 在这里处理Sort属性的变化
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Update: {
      handler(newVal, oldVal) {
        if (oldVal != undefined) {
          this.Update = newVal;
          this.ExportDialogSuo = true;
        }
        // if (newVal) {
        // }

        // 在这里处理columns属性的变化
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Export: {
      handler(newVal, oldVal) {
        if (oldVal != undefined) {
          this.UpdateDialogSuo = true;
        }
        // if (newVal) {
        //     this.UpdateDialogSuo = true;
        // }
        // this.Export = newVal;
        // 在这里处理columns属性的变化
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  mixins: [mixins1],
  components: {
    CompanyQuestion,
    draggable,
    QuestionExport,
    CompanyUpdate,
    QuestionSaved,
    compareCompanys,
    Login,
    DiscreteSlider,
    SupplyChainList,
  },

  data() {
    return {
      PCMoudele: [],
      LastUpdate: "",
      loginDialog: false,
      deledeLaeadsDialog: false,
      InsdustryTable: [],
      companyIncomes: [],
      FilterIndex: 0,
      isNewConfirm: false,
      ComanyFilterList: [],
      isShowTooltip: false,
      leadsPostFilterList: null,
      RiskLoding: false,
      FilterList: [
        {
          name: this.$t("SearchLeadsList.Filters"),
        },
        {
          name: this.$t("SearchLeadsList.Questionnaire"),
        },
      ],
      json_fields: {
        companyTag: "companyTag",
        department: "department",
        email: "email",
        name: "name",
        phone: "phone",
        position: "position",
        linkedin: "linkedin",
      },
      json_fieldsImport: {
        Date: "ie_date",
        Products: "hscode_description_inter",
        "Buyer Names": "import_name",
        Destination: "import_country_inter",
        "Supplier Names": "export_name",
        Origin: "export_country_inter",
        Amount: "amount",
      },
      CompanyObj: {},
      newVal: null,
      DetailsForm: [],
      situationtableData: [],
      distributiontableData: [],
      SaveDialog: false,
      SavyeLeadsSuo: false,
      ExportDialogSuo: false,
      UpdateDialogSuo: false,
      ReSelectCriteria: false,
      templateName: "",
      Compare: false,
      Export: false,
      compareList: [],
      getSearchListType: 1,
      Update: false,
      totle: 0,
      checked: "",
      pageNo: 1,
      disabled: false,
      NationalIndustryActive: "null",
      isRotated: false,
      newDialog: false,
      CompanyQuestionShow: this.$route.query.selectCode == 4 ? true : false,
      NationalIndustryShow: false,

      isOpenSlct: false,
      Compare: false,
      checkList: [],
      aaaid: "",
      CompanyList: [],
      token: localStorage.getItem("token"),
      Saved: undefined,
      isChecked: "",
      tableData: [],
      NewstableData: [],
      DetailsFormImportlist: [],
      riskTotal: "",
      QuestionPageList: [],
      DelIndex: undefined,
      ImporttableData: [],
      leadsList: [],
      leadsListModuleCode: "",
      cascaderProps: {
        // 这里设置最后一层可以多选
        multiple: false,
        checkStrictly: false, // 允许选择不严格
        emitPath: false, // 不发出路径
        label: "optionsContent", // 显示的标签
        value: "id", // 选中的值
        children: "list",
        SaveAnswer: false,
        itemList: {},
        // 其他属性可以根据需要添加
      },
      page: {
        pageNo: 1,
        pageSize: 100,
        total: 0,
      },
      CompanyQuestionList: [],
      isNewQuestion: false,
      CompanyListRandom: [],
      chageItIndex: 0,
      chageItTrue: false,
      indeterminateLeads: false,
      filterOpenMenu: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        "19",
        "20",
      ],
      filterOpenQuesMenu: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20,
      ],
      percentLeadScore: 0,
      percentAccuracyScale: 0,
      filterMenu: [1],
      leadScoreType: [],
      filterList: [],
      filterIndeterminate: false,
      filterCheckAll: false,
      isShowfilterTab: this.$route.query.selectCode == 4 ? true : false,
      loading: true,
      keyword: "", //输入的公司名称
      ContactInfo: {
        aaa_id: "",
        web_site: "",
        company_country: "",
        file_name: "",
      },
      SupplyChain: false,
      openListIndex: null,
    };
  },
  methods: {
    linktoContact(item) {
      let selectKeyMap = {
        1: "Product",
        2: "SIC - Standard Industry Code",
        5: "Global Product Classification(GPC)",
        3: "HSCode - Harmonized System Code",
        4: "AI Assistance",
      };
      let routeData = this.$router.resolve({
        path: "/leads/contact",
        query: {
          id3a: item.aaa_id,
          keyword: this.$route.query.keyword,
          optionsCode: this.$route.query.optionsCode,
          selectCode: this.$route.query.selectCode,
          selectKey: selectKeyMap[this.$route.query.selectCode],
        },
      });

      window.open(routeData.href, "_blank");
    },
    getSearchListTypecode() {
      this.chageItIndex = 0;
      this.getSearchListType++;

      let typenum =
        this.CompanyQuestionList[1].selectedCodes.optionsCode == "SC1001"
          ? 3
          : 2;
      if (this.getSearchListType > typenum) {
        this.getSearchListType = 1;
      }
    },
    ChangeIt() {
      // this.chageItTrue如果点其他的模型不再变化
      this.chageItIndex++;

      if (this.chageItIndex > 2 && !this.chageItTrue) {
        this.getSearchListType++;
        let typenum =
          this.CompanyQuestionList[1].selectedCodes.optionsCode == "SC1001"
            ? 3
            : 2;
        if (this.getSearchListType > typenum) {
          this.getSearchListType = 1;
        }
        this.chageItIndex = 0;
        this.getleadsPostFilter();
      } else {
        this.RiskLoding = true;
        setTimeout(() => {
          this.NationalIndustryShow = false;
          this.NationalIndustryActive = undefined;
          // 获取订的数据
          const countTrueDing = this.CompanyList.filter(
            (item) => item.isDing == true,
          );
          // 从钉盛下的数据过滤
          let filteredData = this.CompanyListRandom.filter(
            (item) => !item.isDing,
          );
          //  下20条数句
          const randomItems = this.getRandomItems(
            filteredData,
            20 - countTrueDing?.length,
          );
          //  合并订的
          this.CompanyList = [...countTrueDing, ...randomItems];
          this.CompanyList.map((item) => {
            item.isRotated = false;
            item.isChecked = false;
          });

          this.RiskLoding = false;
        }, 400);
      }

      this.checked = false;
      this.compareList = [];
      this.$store.dispatch("app/setcollectList", []);
      this.$store.dispatch("app/setchangeList", this.compareList);
      this.setToolsAcive();
    },
    getRandomItems(arr, count) {
      // 随机
      const shuffled = arr.sort(() => 0.5 - Math.random()); // 随机打乱数组
      return shuffled.slice(0, count); // 返回前 count 条数据
    },

    rifghtUpdate() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";
      this.$nextTick(() => {
        this.resizeFn();
      });
    },
    // echarts监听 浏览器宽度改变 echarts改变
    resizeFn() {
      this.CompanyList.map((item) => {
        if (item.chartInstance !== null) {
          item.chartInstance.resize();
        }
      });
    },
    menuCheck(value) {
      let arr2 = [];
      this.ComanyFilterList.forEach((item, index) => {
        if (
          item.selectedCodes != null &&
          item.selectedCodes != undefined &&
          item.selectedCodes.length > 0
        ) {
          arr2.push({
            questionCode: item.leadsQuestions.code,
            selected: item.selectedCodes,
          });
        }
      });
      this.leadsPostFilterList = arr2;
      console.log("menuCheck--", this.leadsPostFilterList);
      this.getleadsPostFilter();
      this.$store.dispatch("app/setchangeList", []);
      this.$store.dispatch("app/setcollectList", []);
      this.setToolsAcive();
      this.checked = false;
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = undefined;
    },

    // feliter切换
    FilterChange(index) {
      if (this.PCMoudele[8].hasPrivilege) {
        this.FilterIndex = index;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    // 获取权限
    getHuokePartPrivilegeList() {
      getHuokePartPrivilege({
        moduleType: 7,
      }).then((res) => {
        if (res.code == 200) {
          this.PCMoudele = res.data;
        }
      });
    },
    SaveMyAnswer() {
      // 是否点击save
      if (this.PCMoudele[5].hasPrivilege) {
        this.$refs.CompanyQuestion.SaveDialog = true;
        if (this.$store.state.app.SeachLabels != "") {
          this.SaveAnswer = true;
          this.isNewQuestion = false;
          this.$refs.CompanyQuestion.templateName =
            this.$store.state.app.SeachLabelsCodeName;
        } else {
          this.SaveAnswer = false;
          this.isNewQuestion = true;
          this.$refs.CompanyQuestion.templateName = "";
        }
        //
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    getPantentList(value) {
      this.CompanyQuestionList = value;
      this.CompanyQuestionList.map((item) => {
        if (Array.isArray(item.selectedCodes)) {
          if (item.selectedCodes.length == 0) {
            item.selectedCodes = null;
          }
          if (item.leadsQuestions.type == 9) {
            item.leadsOptions = item.selectedCodes;
          }
        }
      });
      this.QuestionPageList = this.CompanyQuestionList;

      let arr1 = [];

      value.map((item, index) => {
        if (item.selectedCodes != null && item.selectedCodes != undefined) {
          if (Array.isArray(item.selectedCodes)) {
            arr1.push({
              questionCode: item.leadsQuestions.code,
              selected: item.selectedCodes.map((item) => {
                return item.optionsCode;
              }),
            });
            // }
          } else {
            if (item.leadsQuestions.type == 7) {
              arr1.push({
                questionCode: item.leadsQuestions.code,
                selected: [item.selectedCodes],
              });
            } else {
              arr1.push({
                questionCode: item.leadsQuestions.code,
                selected: [item.selectedCodes.optionsCode],
              });
            }
          }
        }
      });
      this.leadsList = arr1;
      this.labelsCode = "";
      this.leadsListModuleCode = arr1.length > 0 ? arr1[1].selected[0] : "";

      this.getleadsPostFilter();
    },
    // web导出
    exportCompanyWeb(item) {
      this.chageItTrue = true;
      if (this.PCMoudele[14].hasPrivilege) {
        this.aaaId = item.aaa_id;
        this.itemList = item;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }

      // this.DetailsForm = [];
      // this.DetailsForm.push(item);
    },
    DetailsFormConcat() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        let params = {
          page: 1,
          pageSize: 100,
          id3a: this.aaaId,
          website: this.itemList.web_site,
          countryCode: this.itemList.company_country,
        };
        //    return   this.DetailsFormImportlist
        return searchMoreEmail(params).then((res) => {
          if (res.code == 200) {
            if (res.data.contacts.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.contacts;
          } else {
            return [];
          }
        });
      }
    },
    DetailsFormImport() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        return getsearchExport({
          page: 1,
          pageSize: 100,
          export_aaaid: this.aaaId,
          import_aaaid: this.aaaId,
        }).then((res) => {
          if (res.code == 200) {
            if (res.data.rows.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.rows;
          } else {
            return [];
          }
        });
      }
    },
    // 贸易链路导出
    exportCompanyImport(item) {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        this.aaaId = item.aaa_id;
        this.ContactInfo.aaa_id = item.aaa_id;
        this.ContactInfo.web_site = item.web_site;
        this.ContactInfo.company_country = item.company_country;
        this.ContactInfo.file_name = item.company_name_en;
        this.SupplyChain = true;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    clossuoDialogtwo(value) {
      this.SupplyChain = value;
    },

    // 点击跳转
    setNews(row, detail) {
      if (this.token) {
        this.chageItTrue = true;
        // sessionStorage.setItem("company", JSON.stringify(row));
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
          .countryList;
        let SACode1 = "";
        newscountry.map((item) => {
          if (item.countryCode == row.company_country) {
            SACode1 = item.dowjonesCountrycode;
          }
        });
        let routeData = "";
        if (detail == "prife") {
          routeData = this.$router.resolve({
            path:
              "/index/company/details/" +
              row.aaa_id +
              "/background/snapshot?id3a=" +
              row.aaa_id +
              "&companyCountry=" +
              row.company_country +
              "&SACode1=" +
              SACode1 +
              "&companyName=" +
              row.company_name_en +
              "&keword=" +
              this.$route.query.keword,
          });
        } else {
          routeData = this.$router.resolve({
            path:
              "/index/company/details/" +
              row.aaa_id +
              "/publications/news?id3a=" +
              row.aaa_id +
              "&companyCountry=" +
              row.company_country +
              "&SACode1=" +
              SACode1 +
              "&idpower=442" +
              "&companyName=" +
              row.company_name_en +
              "&keword=" +
              this.$route.query.keword,
          });
        }

        window.open(routeData.href, "_blank");
      }
    },
    //新闻跳转
    setid(row) {
      if (row.link == undefined) {
        getPdfLink({ articleRef: row.id }).then((res1) => {
          // let res1 = JSON.parse(crypto.decrypt(res));

          if (res1.data?.includes("http")) {
            let routeData = res1.data;
            window.open(routeData, "_blank");
          } else {
            let routeData = "http://" + res1.data;
            window.open(routeData, "_blank");
          }
          // let routeData = res1.data;
          // window.open(routeData, '_blank');
        });
      }
      if (row.link?.includes("http")) {
        let routeData = row.link;

        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row.link;
        window.open(routeData, "_blank");
      }
      // let routeData = row.url;
      // window.open(routeData, '_blank');
    },

    // 获取公司详情数据
    getCompanyDetailList(item, index) {
      this.chageItTrue = true;
      if (this.PCMoudele[11].hasPrivilege) {
        const isCurrentlyOpen = this.openListIndex === index;
        this.CloseListExpandInfo(index);
        if (!isCurrentlyOpen) {
          item.isRotated = true;
          getCompanyDetail({
            aaaId: item.aaa_id,
            countryCode: item.company_country,
            industryCode: item.isic_code,
          })
            .then((res) => {
              // 更新数据
              item.NewstableData = res.data.news;
              item.prifeTeable = res.data.snapshotVO;
              item.InsdustryTable = res.data.incomePanel.industryIncomes;
              item.companyIncomes = res.data.incomePanel.companyIncomes;

              // 图表配置
              const option = {
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "cross",
                  },
                  formatter: (params) => {
                    let result = params[0].name + "<br/>";
                    params.forEach((item) => {
                      let formattedValue = formatNum(item.value);
                      result +=
                        item.marker +
                        item.seriesName +
                        ": " +
                        formattedValue +
                        "<br/>";
                    });
                    return result;
                  },
                },
                grid: {
                  left: "0%",
                  right: "0%",
                  top: "12%",
                  bottom: "0%",
                  containLabel: true,
                },
                legend: {
                  right: "10px",
                  top: "0px",
                },
                xAxis: [
                  {
                    type: "category",
                    data: item.companyIncomes.map((item) => item.year),
                    axisTick: {
                      show: false,
                    },
                  },
                  {
                    type: "category",
                    data: item.InsdustryTable.map((item) => item.year),
                    axisTick: {
                      show: false,
                    },
                    axisLabel: {
                      show: false,
                    },
                  },
                ],
                yAxis: [
                  {
                    type: "value",
                    axisLabel: {
                      formatter: (value) => {
                        return formatNum(value); // 格式化为千分位
                      },
                      show: false,
                    },
                    axisPointer: {
                      label: {
                        formatter: (params) => {
                          return formatNum(params.value);
                        },
                      },
                    },
                  },
                  {
                    type: "value",
                    axisLabel: {
                      formatter: (value) => {
                        return formatNum(value); // 格式化为千分位
                      },
                      show: false,
                    },
                    axisPointer: {
                      label: {
                        formatter: (params) => {
                          return formatNum(params.value);
                        },
                      },
                    },
                  },
                ],
                series: [
                  {
                    name: "Industry Mean",
                    type: "bar",
                    barWidth: "15",
                    itemStyle: { color: "#8E86DD" },
                    emphasis: {
                      itemStyle: {
                        color: "#8E86DD",
                      },
                    },
                    data: item.InsdustryTable.map((item) => item.income),
                  },
                  {
                    name: "Target Subject Revenue",
                    type: "line",
                    barWidth: "20",
                    yAxisIndex: 1,
                    itemStyle: { color: "#FF7600" },
                    emphasis: {
                      itemStyle: {
                        color: "#FF7600",
                      },
                    },
                    data: item.companyIncomes.map((item) => item.income),
                  },
                ],
              };

              // 获取图表 DOM
              const chartDom = this.$refs.ImportEchart[index];
              let chart = this.$echarts.getInstanceByDom(chartDom);

              // 如果没有找到图表实例，则初始化一个新的图表
              if (!chart) {
                chart = this.$echarts.init(chartDom);
                item.chartInstance = chart; // 存储图表实例
              } else {
                // 如果找到了图表实例，先销毁它
                chart.dispose();
                // 重新初始化图表
                chart = this.$echarts.init(chartDom);
                item.chartInstance = chart; // 更新存储的图表实例
              }

              // 设置图表选项
              this.$nextTick(() => {
                if (chart) {
                  chart.setOption(option); // 仅在 chart 存在时设置选项
                }
              });

              // 更新数据
              this.$set(item, "item.NewstableData", res.data.news);
              // this.CompanyList[index].chartInstance = chart; // 更新 CompanyList 中的图表实例
            })
            .catch((error) => {
              console.error("error:", error);
            });
        }
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    // 公司对比返回
    CompareShow(val) {
      this.Compare = false;
      this.checked = "";
      this.$store.dispatch("app/setchangeList", []);
      this.$store.dispatch("app/setcollectList", []);
      this.setTools();
    },
    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 工具栏高亮控制
    setToolsAcive() {
      this.$store.dispatch("app/setTools", {
        name: "Optimize",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });

      //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
    },
    // 收藏

    CollectCheckBook() {
      this.checkList = this.$store.state.app.collectList;
      let collect = [];
      this.$store.state.app.changeList.map((item) => {
        collect.push(item.aaa_id);
      });

      // this.$store.state.app.changeLis;
      this.checkList.forEach((item) => {
        addItems({
          collectionId: item,
          items: collect,
        }).then((Res) => {
          if (Res.code == 200) {
            this.CompanyList.map((ite) => {
              if (collect.includes(ite.aaa_id)) {
                ite.isFavorite = true;
              }
            });

            // this.$router.go(0);
            this.$message({
              message: Res.msg,
              center: true,
              type: "success",
            });
          } else {
            this.$message({
              message: Res.msg,
              center: true,
              type: "error",
            });
          }
        });
      });
    },
    findPartnerDetailList() {
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
      getLeadsQuestions({
        leadsAnswersHead: {
          id: this.labelsCode,
          userId: userinfo.id,
          title: null,
          creatTime: null,
          updateTime: null,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.CompanyQuestionShow = false;
          this.CompanyQuestionList = [];
          this.CompanyQuestionList = res.data?.leadsQuestionsVOList.filter(
            (item) =>
              item.selectedOptions != null || item.leadsQuestions.type == 5,
          );
          this.CompanyQuestionList.map((item, index) => {
            if (item.leadsQuestions.type == 9) {
              item.leadsOptions = JSON.parse(item.selectedOptions);
            }
            item.selectedCodes = JSON.parse(item.selectedOptions);
            if (index == 0) {
              item.showCode = Number(item.selectedCodes.id);
            }
            //Yes,no
            if (item.leadsQuestions.type == 5) {
              item.selectedOptions =
                item.selectedCodes?.length > 0 ? "Yes" : "No";
            }
          });
          this.QuestionPageList = this.CompanyQuestionList;
          this.getLeadsList();
          this.getleadsPostFilter();
        }
      });
    },

    //无调查问卷页面时，初始调用
    getLeadsPostFilterNew() {
      this.getleadsPostFilter();
      this.setToolsAcive();
    },
    //刷新筛选
    handlefilterCheckAll() {
      this.filterIndeterminate = false;
    },

    //获取首页类型
    getSelectCode() {
      let codeType = this.$route.query.selectCode;
      if (codeType == "3") {
        codeType = "HS";
      } else if (codeType == "1") {
        codeType = "CPC";
      } else if (codeType == "2") {
        codeType = this.$route.query.optionsType;
      }
      return codeType;
    },

    getleadsPostFilterchangeSearch() {
      this.checked = false;
      this.compareList = [];
      this.leadsPostFilterList = null;
      this.$store.dispatch("app/setcollectList", []);
      this.$store.dispatch("app/setchangeList", this.compareList);
      this.setToolsAcive();
      this.getleadsPostFilter();
    },
    // 获取leadsPostFilter
    getleadsPostFilter() {
      this.RiskLoding = true;
      let param = {};
      let paramOther = {
        leadsPostFilter: this.leadsPostFilterList,
        answersHeadId: null,
        codeType: this.getSelectCode(),
        code: this.$route.query.optionsCode,
        page: 1,
        pageSize: 100,
        type: this.searchListType,
      };
      let paramAI = {
        leads: this.leadsList,
        leadsPostFilter: this.leadsPostFilterList,
        answersHeadId: this.labelsCode,
        page: 1,
        pageSize: 100,
        type: this.getSearchListType,
      };

      if (this.$route.query.selectCode != "4") {
        param = paramOther;
      } else {
        param = paramAI;
      }
      leadsPostFilter(param).then((res) => {
        if (res.code == 200) {
          res.data?.leadsQuestionsVOList.map((item) => {
            if (item.selectedCodes != null) {
              item.selectedCodes = [JSON.parse(item.selectedCodes).optionsCode];
            } else {
              item.selectedCodes = [];
            }
          });
          // 保存原始数据
          this.originalComanyFilterList = res.data?.leadsQuestionsVOList ?? [];
          this.ComanyFilterList = [...this.originalComanyFilterList];
          let arr2 = [];
          let ops = [];
          this.ComanyFilterList.forEach((item, index) => {
            if (
              item.selectedCodes != null &&
              item.selectedCodes != undefined &&
              item.selectedCodes.length > 0
            ) {
              arr2.push({
                questionCode: item.leadsQuestions.code,
                selected: item.selectedCodes,
              });
            } else {
              item.selectedCodes = [];
            }
            ops.push({
              questionContent: item.leadsQuestions.questionContent,
              code: item.leadsQuestions.code,
            });
          });
          this.filterList = ops;
          // 默认全选
          this.leadScoreType = this.filterList.map((item) => item.code);
          this.filterCheckAll = true;
          this.filterIndeterminate = false;
          this.getSearchList(arr2);
        }
      });
    },
    // 获取leadsList
    getLeadsList() {
      let arr1 = [];
      this.CompanyQuestionList.forEach((item) => {
        if (item.selectedCodes != null) {
          if (Array.isArray(item.selectedCodes)) {
            if (item.selectedOptions != "[]") {
              arr1.push({
                questionCode: item.leadsQuestions.code,
                selected: item.selectedCodes.map((item) => {
                  return item.optionsCode;
                }),
              });
            }
          } else {
            if (item.leadsQuestions.type == 7) {
              arr1.push({
                questionCode: item.leadsQuestions.code,
                selected: [item.selectedCodes],
              });
            } else {
              arr1.push({
                questionCode: item.leadsQuestions.code,
                selected: [item.selectedCodes.optionsCode],
              });
            }
          }
        }
      });
      this.leadsList = arr1;
      this.leadsListModuleCode = arr1[1].selected[0];
    },
    // 获取列表数据
    getSearchList(leadsPostFilter) {
      this.RiskLoding = true;
      let param = {};
      let paramOther = {
        leadsPostFilter: this.leadsPostFilterList,
        answersHeadId: null,
        codeType: this.getSelectCode(),
        code: this.$route.query.optionsCode,
        page: 1,
        pageSize: 100,
        type: this.searchListType,
      };
      let paramAI = {
        leads: this.leadsList,
        answersHeadId: this.labelsCode,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        type: this.getSearchListType,
        leadsPostFilter: leadsPostFilter,
      };

      if (this.$route.query.selectCode != "4") {
        param = paramOther;
      } else {
        param = paramAI;
      }

      findPartnerDetail(param).then((res) => {
        if (res.code == 200 && res.data != null) {
          this.CompanyQuestionShow = false;
          let parentTable = [];
          let list = (parentTable = res.data.rows);
          list = list.map((item, index) => {
            let countryImg = this.getCountryImgUrl(item.company_country);
            if (countryImg) {
              let flag = require("../../../../static" + countryImg);
              parentTable[index].flag = flag;
              this.refresh++;
            }
          });

          this.CompanyList = parentTable;
          this.CompanyList.map((item) => {
            item.NewstableData = [];
            item.prifeTeable = {};
            item.InsdustryTable = [];
            item.companyIncomes = [];

            item.chartInstance = null;
          });
          this.CompanyListRandom = parentTable;
          this.riskTotal = res.data.total;
          this.RiskLoding = false;
        } else {
          this.riskTotal = "";
          this.CompanyList = [];
          this.RiskLoding = false;
        }
      });
    },
    // 删除元素
    DelClick(item, index) {
      if (this.PCMoudele[13].hasPrivilege) {
        this.DelIndex = index;
        this.deledeLaeadsDialog = true;
        // this.CompanyList.map(item=>{
        //     item.isRotated=false
        // })

        // this.NationalIndustryShow = false
        // this.nationalCompetitivenessIndex=undefined
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    // 删除元素
    deLaeadsDialogubmit() {
      this.CompanyList = this.CompanyList.slice(0, 20);
      this.CompanyList.splice(this.DelIndex, 1);
      this.compareList = this.CompanyList.filter((item) => item.isChecked);
      // this.compareList.splice(this.DelIndex, 1)

      if (this.compareList.length == 0) {
        this.compareList.map((item) => {
          item.isChecked = false;
        });

        this.setToolsAcive();
        this.$store.dispatch("app/setcollectList", []);
        this.$store.dispatch("app/setchangeList", this.compareList);
        this.checked = false;
      } else {
        this.$store.dispatch("app/setTools", {
          name: "compare",
          key: "isActive",
          value: this.compareList.length > 0 && this.compareList.length < 4,
        });
      }
      this.$store.dispatch("app/setchangeList", this.compareList);

      this.CompanyList.map((item) => {
        item.isRotated = false;
      });

      this.NationalIndustryShow = false;
      this.NationalIndustryActive = undefined;
      this.deledeLaeadsDialog = false;
    },
    // 取消钉
    CansoleClick(item, index) {
      item.isDing = false;
      let dingList = this.CompanyList.filter((item) => item.isDing == true);
      const removedItem = this.CompanyList.splice(index, 1)[0];
      this.CompanyList.splice(dingList.length, 0, removedItem);
      // findPartnerPcnotDing({
      //     aaaId: item.aaa_id,
      //     answersHeadId: this.labelsCode,

      // }).then((res) => {
      // });
    },
    // 钉
    DingClick(item, index) {
      if (this.PCMoudele[12].hasPrivilege) {
        this.chageItTrue = true;
        // if (this.labelsCode) {
        item.isDing = true;
        // item.isRotated=false
        this.CompanyList.map((ite) => {
          ite.isRotated = false;
        });
        const removedItem = this.CompanyList.splice(index, 1)[0];
        this.NationalIndustryShow = false;
        this.NationalIndustryActive = undefined;
        // 将删除的数据插入到数组最开始的位置
        this.CompanyList.unshift(removedItem);
        // 保存钉
        // findPartnerPcding({
        //     aaaId: item.aaa_id,
        //     answersHeadId: this.labelsCode,
        // }).then((res) => {
        // });
        // } else {
        //     this.SaveMyAnswer()

        // }
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    // 移动
    onMove(e) {
      if (e.relatedContext.element.isDing == true) return false;
      return true;
    },
    // 点击列表出现右侧数据
    scrollActiveItemToTop() {
      const list = document.querySelector(".risk-center-list");
      const listItems = document.querySelectorAll(".conpany-center-list");
      if (
        !list ||
        listItems.length === 0 ||
        this.NationalIndustryActive == null
      ) {
        return;
      }
      const targetItem = listItems[this.NationalIndustryActive];
      if (!targetItem) {
        return;
      }
      list.scrollTop = targetItem.offsetTop;
    },
    CloseListExpandInfo(index = null) {
      if (this.openListIndex !== null) {
        const prevItem = this.CompanyList[this.openListIndex];
        if (prevItem) prevItem.isRotated = false;
      }

      this.openListIndex =
        index !== null && this.openListIndex !== index ? index : null;
    },
    NationalIndustry(item, index) {
      this.chageItTrue = true;
      if (this.PCMoudele[16].hasPrivilege) {
        this.CloseListExpandInfo();
        this.LastUpdate = item.update_year;
        getCompanyIndustryInfo({
          aaaId: item.aaa_id,
          countryCode: item.company_country,
        }).then((Res) => {
          if (Res.code == 200) {
            this.CompanyObj = Res.data;

            this.resizeFn();
          } else {
            this.CompanyObj = null;
            this.resizeFn();
          }
        });

        this.NationalIndustryActive = index;

        if (this.NationalIndustryActive != undefined) {
          this.NationalIndustryShow = true;
        } else {
          this.NationalIndustryShow = false;
        }

        this.$nextTick(() => {
          this.scrollActiveItemToTop();
        });
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    // 全选操作
    changeItemChecked(value) {
      const checkedCount = this.CompanyList.filter(
        (item) => item.isChecked,
      ).length;
      const totalCount = 20;

      this.checked = checkedCount === totalCount;
      this.indeterminateLeads = checkedCount > 0 && checkedCount < totalCount;

      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.$store.dispatch("app/setchangeList", selectCompany);
      this.compareList = selectCompany;
      // this.$nextTick(() => { });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true && this.Compare == false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: selectCompany.length > 0,
      });
    },
    // 全选操作
    changeSlctAll(value) {
      this.CompanyList.slice(0, 20).forEach((item) => {
        item.isChecked = value;
      });
      this.indeterminateLeads = false;
      let selectCompany = this.CompanyList.slice(0, 20).filter(
        (item) => item.isChecked,
      );
      this.compareList = selectCompany;
      this.$store.dispatch("app/setchangeList", selectCompany);
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: selectCompany.length > 0 && selectCompany.length < 101,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
      });
      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true && this.Compare == false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: selectCompany.length > 0 && selectCompany.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: selectCompany.length > 0,
      });
      this.$store.dispatch("app/setchangeList", selectCompany);
      sessionStorage.setItem("riskScanList", JSON.stringify(selectCompany));
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },
    SavedcloseDialog(value) {
      this.SavyeLeadsSuo = value;
      this.Saved = undefined;
      // this.$router.go(0);
    },
    ExportDialog(value) {
      this.ExportDialogSuo = value;
    },
    UpdateDialog(value) {
      this.UpdateDialogSuo = value;
    },

    // setTools
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
    }, // getDetail
    getDetail() {
      this.$router.push({
        path: "/index/risk/details/fgfdsg/riskdetails",
      });
    }, // setThemeColor
    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#8E86DD");
      this.$store.dispatch("app/setSearchType", "risk");
    },
    // srcviewscompanylistriskvueMethodEnd

    // 滑动标尺
    onChangeLeadScRuler(val) {},
    onChangeAccuracyScRuler(val) {},

    //filters 筛选
    onChangeParams(val) {
      // 更新全选和半选状态
      this.updateFilterCheckAllStatus();
    },

    // 更新全选和半选状态
    updateFilterCheckAllStatus() {
      if (this.filterList.length === 0) {
        this.filterCheckAll = false;
        this.filterIndeterminate = false;
        return;
      }

      const totalOptions = this.filterList.length;
      const checkedCount = this.leadScoreType.length;

      this.filterCheckAll = checkedCount === totalOptions;
      this.filterIndeterminate =
        checkedCount > 0 && checkedCount < totalOptions;
    },

    // 全选/取消全选
    onFilterCheckAll(val) {
      this.leadScoreType = val ? this.filterList.map((item) => item.code) : [];
      this.filterIndeterminate = false;
    },

    // 清除所有筛选
    clearFiltersParams() {
      this.leadScoreType = [];
      this.filterCheckAll = true;
      this.filterIndeterminate = true;
      this.getleadsPostFilterchangeSearch(); //重新获取筛选数据
    },
    // 确认筛选
    confirmFilter() {
      this.filterMenu = [];
      if (this.leadScoreType.length === 0) {
        this.ComanyFilterList = [];
      } else if (this.leadScoreType.length === this.filterList.length) {
        this.ComanyFilterList = [...this.originalComanyFilterList];
      } else {
        this.ComanyFilterList = this.originalComanyFilterList.filter((item) =>
          this.leadScoreType.includes(item.leadsQuestions.code),
        );
      }
      // 更新全选和半选状态
      this.updateFilterCheckAllStatus();
    },

    // 公司名称模糊搜索
    debouncedRemoteMethodCompany: _.debounce(function (query) {
      this.loading = false;
      this.remoteMethodSeachCompany(query, 6);
    }, 300), // 300毫秒延迟
    debouncedRemoteMethodCompany3: _.debounce(function (query) {
      this.loading = false;
      this.remoteMethodSeachCompany(query, 7);
    }, 300), // 300毫秒延迟
    async remoteMethodSeachCompany(query, page) {
      if (query !== "") {
        this.loading = true;
        this.keyword = query;

        let params = {
          company_name: query,
          page: 1,
          pageSize: 100,
        };
        let res = await searchCompany(params);

        let parentTable = [];
        if (res.code == 200) {
          setTimeout(() => {
            let list = (parentTable = res.data.rows);

            //查找本地图片
            list = list.map((item, index) => {
              let countryImg = this.getCountryImgUrl(item.company_country);
              if (countryImg) {
                let flag = require("../../../../static" + countryImg);
                parentTable[index].flag = flag;
              }
            });
            let index = this.QuestionPageList.findIndex(
              (item) =>
                item.leadsQuestions.type == 9 &&
                item.leadsQuestions.code == page,
            );
            let seachCompanyList = [];
            seachCompanyList = parentTable.map((item) => {
              return {
                optionsCode: item.aaa_id,
                optionsContent: item.company_name_en
                  ? item.company_name_en
                  : item.company_name,
                flag: item.flag,
                aaa_id: item.aaa_id,
              };
            });
            this.QuestionPageList[index].leadsOptions = seachCompanyList;

            this.loading = false;
          }, 10);
        } else {
          if (res.code == "1002") {
            this.$message({
              message: res.msg,
              center: true,
              type: "error",
            });
          } else {
            this.loading = false;
          }
        }
      }
    },

    //调查问卷重选
    debouncedRemoteMethodfocus(query) {
      // console.log(`query`, query);
      // this.$refs.upSelectProductSearch[0].visible=false
    },
    debouncedRemoteMethod: _.debounce(function (query) {
      this.remoteMethod(query, 3);
    }, 300), // 300毫秒延迟
    // 模糊 搜索
    remoteMethod(query, page) {
      if (query !== "") {
        this.keyword = query;
        this.loading = true;
        let industryCode = [
          "FI1001",
          "IF1001",
          "GM1001",
          "GM1003",
          "SC1001",
          "SC1003",
          "ID1001",
          "ID1003",
        ];
        if (
          industryCode.includes(
            this.QuestionPageList[1].selectedCodes.optionsCode,
          )
        ) {
          getIndustryCodeFilterList({
            optionsContent: query,
          }).then((res) => {
            if (res.code == 200) {
              setTimeout(() => {
                this.loading = false;

                let index = this.QuestionPageList.findIndex(
                  (item) => item.leadsQuestions.type == 8,
                );
                this.QuestionPageList[index].leadsOptions = res.data;
              }, 10);
            }
          });
        } else {
          getLeadsProductFilterList({
            productNameDesc: query,
            pageSize: 50,
          }).then((res) => {
            if (res.code == 200) {
              setTimeout(() => {
                this.loading = false;

                let index = this.QuestionPageList.findIndex(
                  (item) => item.leadsQuestions.type == 8,
                );
                this.QuestionPageList[index].leadsOptions = res.data;
              }, 10);
            }
          });
        }
      }
    },
    //高亮
    highlightKeyword(text) {
      if (!this.keyword) {
        return text;
      }
      const regex = new RegExp(this.keyword, "gi");
      return text.replace(
        regex,
        (match) => `<span class="highlight">${match}</span>`,
      );
    },
    handleRadioChange(item, value) {
      item.selectedOptions = value;
      this.menuQuesChange();
    },
    // 刷新列表
    onRefreshCompanyList(templateName) {
      this.templateName = templateName;
      let arrQusetion = this.CompanyQuestionList.map((item, index) => {
        if (Array.isArray(item.selectedCodes)) {
          if (item.selectedCodes.length > 0) {
            item.selectedCodes.map((ite) => {
              ite.list = null;
            });
          } else {
            item.selectedCodes = null;
          }
        }
        if (item.leadsQuestions.type == 5) {
          item.selectedOptions == "No" ? (item.selectedCodes = null) : "";
        }
        return {
          ...item,
          selectedOptions:
            item.selectedCodes == null
              ? null
              : JSON.stringify(item.selectedCodes),
          selectedCodes: item.selectedCodes,
        };
      });
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
      saveLeadsAnswers({
        leadsAnswersHead: {
          id: this.$store.state.app.SeachLabels,
          userId: userinfo.id,
          title: this.templateName,
          creatTime: null,
          updateTime: null,
        },
        leadsQuestionsVOList: arrQusetion,
      }).then((res) => {
        if (res.code == 200) {
          this.isNewQuestion = false;
          //刷新list
          this.findPartnerDetailList();
          this.setToolsAcive();
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },

    // 处理标签删除事件，确保至少保留一个选项
    handleRemoveTag(val, item) {
      let targetArr;
      if (
        item.selectedCodes &&
        item.selectedCodes.optionsContent &&
        Array.isArray(item.selectedCodes.optionsContent)
      ) {
        targetArr = item.selectedCodes.optionsContent;
      } else if (item.selectedCodes && Array.isArray(item.selectedCodes)) {
        targetArr = item.selectedCodes;
      }
      if (targetArr) {
        // 如果当前选中项数量小于等于1，不允许删除
        if (targetArr.length <= 1) {
          this.$message.warning("Keep at least one option");
          this.$nextTick(() => {
            if (targetArr.length === 0) {
              targetArr.push(val);
            }
          });
        } else {
          this.getPantentList(this.CompanyQuestionList);
        }
      }
    },
    //问卷修改
    menuQuesChange() {
      this.getPantentList(this.CompanyQuestionList);
    },
  },
  computed: {},
  created() {
    this.setToolsAcive();
  },
  mounted() {
    //
    this.setThemeColor();
    this.setToolsfalse();
    if (this.token) {
      window.addEventListener("resize", this.resizeFn);

      this.getHuokePartPrivilegeList();

      if (!this.isShowfilterTab) {
        this.getLeadsPostFilterNew();
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
};
</script>
<style scoped>
.leads_right_top_num {
  color: #999999;
  font-size: 14px;
  line-height: 40px;
  text-align: left;
  margin: 0 20px 10px;
  overflow: hidden;
}

.left_menu {
  width: auto;
  height: auto;
}

.hidemenu {
  display: block;
  width: 0 !important;
  padding-left: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-right: 0 !important;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.scrollbar_risk_right {
  width: calc(100% - 340px);
  display: flex;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  flex-direction: column;
}

.scrollbar {
  overflow: hidden;
  /* overflow-y: auto; */
}

.left_no_menu {
  width: 100% !important;
}

.pb10 {
  padding-bottom: 10px;
}

.iconbgActiveBG {
  background: #eceaff !important;
}

.risk-right {
  display: flex;
  flex-direction: column;
  width: 600px;
  padding: 20px;
  background: #eceaff;
  height: 100%;
  border-radius: 10px;
  position: absolute;
  top: 0px;
  right: 0px;
}

.risk-right /deep/ .el-table__body-wrapper {
  min-height: auto !important;
}

.risk_right_box_header {
  margin: 0 20px;
  padding: 20px 0;
  border-bottom: 1px solid #cccccc;
}

.risk_right_box {
  overflow: auto;
  flex: 1;
  padding: 0 20px 20px;
  border-radius: 4px;
  background: #eceaff;
  /* box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12); */
}

.risk-center-list {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px;
}

.Upadetime {
  font-size: 18px;
  color: #666666;
  margin-right: 30px;
}

.flex_center_between_box p {
  font-size: 24px;
  color: #1a2332;
  margin-bottom: 10px;
  display: flex;
}

.risk-right-content {
  padding: 20px 0;
  border-top: 1px solid #cccccc;
}

.risk-right-content:first-child {
  border-top: none !important;
}

.risk-right-content-title {
  font-size: 20px;
  color: #1a2332;
  margin-bottom: 20px;
  font-family: "Arial Bold";
}

.risk_right_title {
  font-size: 24px;
}

.right-txt {
  font-family: "Arial";
  text-align: right;
  font-size: 18px;
  color: #1a2332;
}

.left-txt {
  font-size: 18px;
  color: #666666;
}

.margin16 {
  margin-top: 16px;
}

.highlight-cell {
  background-color: #f3f3f3 !important;
}

.risk-right .el-table .cell {
  color: #1a2332;
}

.risk-right .el-table th.el-table__cell {
  background-color: #f3f3f3 !important;
}

.conpany-center-list {
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin-bottom: 10px;
}

.conpany-center-list-left {
  font-size: 24px;
  color: #1a2332;
  display: flex;
  align-items: flex-start;
  width: fit-content;
  flex: 1;
}

.conpany-center-list-left {
  width: calc(100% - 144px);
}

.conpany-center-list-right {
  width: 144px;
}

.indexPositon {
  color: #685ed1;
}

.indexPositonactive {
  color: #999999;
  font-family: "Arial Bold";
}

.list-text-color {
  font-size: 18px !important;
  color: #666666 !important;
  display: flex;
  align-items: center;
  line-height: 30px;
}

.list-text-color .single,
.list-text-color span {
  color: #1a2332 !important;
  margin-left: 10px;
}

/* .overexperise {
  max-width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
} */

.list-text-color img {
  width: 46px;
  height: 32px;
  margin-right: 5px;
}

.iconbg {
  width: 50px;
  height: 50px;
  background: #eeeeee;
  border-radius: 50%;
  cursor: pointer;
  color: #8e86dd;
}

.conpany-center-list-right p {
  justify-content: flex-end;
}

.bottom-list-echarts {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.bottom-list-echarts-li {
  padding: 20px 20px 10px;
  background: #f5f5f5;
  width: 33.33%;
  height: 260px;
  flex: 1;
}

.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  cursor: pointer;
  transform: rotate(0deg);
  color: #685ed1;
  font-size: 16px;
}

.rotate {
  transform: rotate(180deg);
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.x 中 */ {
  opacity: 0;
  /* 初始透明度 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  /* 淡入淡出动画 */
}

.iconbgActive {
  background-color: #8e86dd;
}

.left_menu_filter,
.left_menu_title {
  width: calc(100% - 80px);
  font-size: 18px;
  font-family: "Arial Bold";
}

.left_menu_title {
  padding-bottom: 10px;
}

.left_menu_title {
  color: #1a2332;
}

.left_menu_filter {
  color: #8e86dd;
}

.left_menu_question p {
  font-size: 18px;
  color: #1a2332;
  margin-bottom: 20px;
  font-family: "Arial Bold";
}

.left_menu_question /deep/ .el-select .el-input__suffix {
  display: none;
}

.left_menu_question /deep/ .el-select .el-input.is-focus .el-input__inner,
.left_menu_question /deep/ .el-select .el-input__inner:focus {
  border: 1px solid #cccccc !important;
  border-color: #8e86dd !important;
  line-height: 2.428571rem !important;
}

.left_menu_question {
  border-bottom: 1px solid #dddddd;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.FilterQuestion .left_menu_question {
  padding-bottom: 0;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  border-color: #cccccc;
  color: #999999;
  line-height: 36px;
}
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #8e86dd !important;
}

.left_menu_bottom {
  font-size: 18px;
  color: #1a2332;
}

.Answerbutoon {
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  background: #8e86dd;
  border-radius: 10px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  width: 300px;
}
.Answerbutoon:disabled {
  background-color: #eeeeee;
  color: #999999;
}
.AnswerbutoonBox {
  position: absolute;
  bottom: 20px;
  z-index: 999;
  background: rgb(245, 245, 245);
}

.bottom-list-echarts-li-left {
  border-right: 1px solid #dddddd;
  padding-right: 20px;
  width: 50%;
}

.bottom-list-echarts-li-right {
  padding-left: 20px;
  width: 50%;
}

.bottom-list-echarts-li-left-text {
  font-size: 14px;
  line-height: 30px;
  color: #1a2332;
  width: 100%;
  gap: 15px;
}

.bottom-list-echarts-head {
  font-size: 18px !important;
  color: #1a2332;
  font-family: "Arial bold";
}

.bottom-list-echarts-box {
  padding-top: 5px;
  margin-top: 5px;
  border-top: 1px solid #dddddd;
}

.news-text {
  font-size: 14px;
  color: #8e86dd;
  margin-bottom: 10px;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.bottom-list-echarts-li ul {
  padding-top: 10px;
  border-top: 1px solid #dddddd;
  max-height: 73%;
  overflow: hidden;
}

.MoreCompany {
  font-size: 14px;
  color: #8e86dd;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  text-decoration-line: underline;
}

.profit-txt {
  width: 125px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.color1290C9 {
  text-align: right;
}

.btn_exportCollect {
  background: #8e86dd !important;
  color: #ffffff !important;
}

button:disabled {
  cursor: no-drop !important;
}

.el-popover {
  padding: 10px !important;
  min-width: auto;
}

.leads_cont {
  height: 100%;
  display: flex;
  background: #f5f5f5;
}

.leads_cont_left {
  width: 340px;
  position: relative;
  overflow: hidden;
  transition: 0.2s;
  flex: none;
  padding: 10px 10px 10px 20px;
}

.right_cont_box {
  height: 100%;
  overflow-y: auto;
}

.Country_img {
  width: 30px;
  height: 18px;
  margin-right: 8px;
}

.Country_name {
  line-height: 18px;
  font-size: 16px;
}

.Search_Company {
  margin-bottom: 0.5rem;
  height: 3rem;
}

.yellownone,
.yellow {
  width: 50%;
  height: 36px;
  padding: 8px 19px;
  line-height: 36px;
  text-align: center;
}

.yellow {
  font-family: "Arial Bold";
  color: #fff;
  background-color: #8e86dd;
  border-radius: 10px;
}

.yellownone {
  color: #1a2332;
}

.flilterClass {
  width: 100%;
  height: 40px;
  font-size: 16px;
  color: #1a2332;
  background: #dddddd;
  border-radius: 10px;
  cursor: pointer;
  border: 2px solid #ddd;
}

.left_menu /deep/ .el-checkbox__label {
  width: 100%;
}

.coll_child_name {
  flex: 1;
  width: 100%;
}

.coll_child /deep/ .el-radio {
  color: #1a2332;
  line-height: 1;
  font-size: 14px !important;
  cursor: pointer;
  white-space: nowrap;
  outline: 0;
  margin-right: 0px !important;
  margin-bottom: 10px !important;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #8e86dd;
  background: #fff;
}

/deep/.el-radio__input.is-checked .el-radio__inner::after {
  background: #8e86dd;
}

/deep/.is-checked .el-checkbox__label .coll_child_name {
  /* color: #8E86DD; */
  color: #8e86dd !important;
}

/deep/.scrollbar .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8e86dd !important;
  border-color: #8e86dd !important;
}

.font_color,
/deep/.scrollbar .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #8e86dd !important;
}

.huanyipi {
  color: #685ed1;
  cursor: pointer;
  font-size: 16px;
}

.left_menu-headbox {
  transition: 0.2s;
}
.left_menu_content_all,
.left_menu_content {
  overflow-y: auto;
  overflow-x: hidden;
}
.left_menu_content {
  height: calc(100% - 140px);
}
.left_menu_content_all {
  height: 100%;
}
::v-deep
  .left_menu_content
  .left_menu
  .el-checkbox__input.is-checked
  .el-checkbox__inner {
  background: #8e86dd;
  border-color: #8e86dd;
}

.margin-left5 {
  margin-left: 5px;
}

::v-deep .el-tag.el-tag--info {
  border-color: #ccc !important;
  color: #1a2332 !important;
  border-radius: 23px;
  background: #ffffff;
}

.left_menu_question /deep/ .el-tag.el-tag--info {
  font-size: 16px;
}

.icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
}

.iconright {
  font-size: 26px;
}

.icontop {
  font-size: 24px;
}

.list-label {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.risk-center-list-box {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  flex: 1;
}

.leads_cont_progress_txt {
  font-size: 18px;
}

.leads_cont_progress_pre >>> .el-progress-bar {
  padding-right: 0px;
  margin-right: -40px;
}

.leads_cont_progress_pre {
  width: 280px;
}

.leads_cont_progress_pre_sc >>> .el-progress__text,
.leads_cont_progress_pre >>> .el-progress__text {
  position: absolute;
  top: -17px;
  font-size: 18px;
}

.con_cen_list_right_btn {
  margin-top: 34px;
}

.leads_cont_progress_box {
  flex-wrap: wrap;
  gap: 30px;
}

.leads_cont_progress {
  padding: 10px;
  background: #f5f5f5;
  border-radius: 10px;
}

.leads_cont_progress .list-text-color {
  color: #1a2332 !important;
}

.list-text-color .single {
  width: 65%;
}

.dialog_tip_img {
  width: 80px;
}

.left_menu_clear {
  position: relative;
}

.clear_all {
  position: absolute;
  bottom: 8px;
  right: 0px;
  font-weight: 400;
  font-size: 16px;
  color: #1a2332;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
}

.clear_all .iconfont {
  font-size: 16px;
  color: #ff6a6a;
  margin-right: 6px;
}

.fiter_ic {
  display: inline-block;
  transition: transform 0.5s ease;
  cursor: pointer;
  transform: rotate(92deg);
  color: #8e86dd;
  font-size: 12px;
}

.filter_first_box {
  border-top: 1px solid #f5f5f5;
  margin-bottom: -1px;
}

.left_menu .filter_first_item /deep/ .el-collapse-item__header {
  padding-left: 0;
}

.filter_first_item /deep/ .el-collapse-item__arrow {
  display: none;
}
.left_menu
  /deep/
  .el-collapse-item
  .el-collapse-item__header
  i.el-collapse-item__arrow {
  position: absolute;
  left: 0 !important;
  right: auto;
}

.is-active .fiter_ic {
  transform: rotate(-90deg);
}

::v-deep .el-table th.el-table__cell,
::v-deep .el-table--enable-row-transition .el-table__body td.highlight-cell {
  background-color: #f3f3f3;
  font-family: "Arial Bold";
}

::v-deep td.highlight-cell .cell .table-content {
  font-family: "Arial Bold";
}
.question_box >>> .el-tag.el-tag--info .el-tag__close {
  background: #f56b6b;
  color: #fff;
  display: none;
}
.question_box >>> .el-tag.el-tag--info:not(:only-of-type) .el-tag__close {
  display: block;
}
.left_menu .filter_first_item {
  position: relative;
}
.filter_first_checkbox {
  position: absolute;
  top: 34px;
  right: 0px;
  font-size: 16px;
  padding: 20px;
  color: #1a2332;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  z-index: 9;
  text-align: center;
}
.filter_first_btn {
  width: 200px;
}
::v-deep .el-select-dropdown__item.selected {
  color: #1a2332 !important;
}
::v-deep .highlight {
  color: #f56c6c;
  font-weight: bold;
}
.el-saech-eye {
  position: absolute;
  right: 5px;
  top: 0px;
  color: #1a2332;
  font-size: 14px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  overflow-y: auto;
  /* padding: 12% 0 2%; */
}

.modal-container {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: relative;
  width: 800px;
  height: auto;
  /* margin: 0 auto; */
  z-index: 1001;
  background: #ffffff;
  border-radius: 22px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
/deep/ .el-collapse-item__wrap {
  border-bottom: 1px solid #eeeeee;
}

.filter_first_checkbox
  /deep/
  .el-checkbox__input.is-indeterminate
  .el-checkbox__inner,
.filter_first_checkbox /deep/ .el-checkbox.is-checked .el-checkbox__inner {
  background-color: #8e86dd;
  border-color: #8e86dd;
}

.icon_sanjiaoLocation {
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: #000000;
  cursor: pointer;
}

@media screen and (max-width: 1920px) {
  .modal-container {
    width: 600px;
  }

  .left_menu_content {
    height: calc(100% - 100px);
  }

  .left_menu_question p {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .leads_cont_left {
    width: 300px;
    padding: 8px 8px 8px 16px;
  }

  .scrollbar_risk_right {
    width: calc(100% - 300px);
    padding: 10px 7px 7px;
  }

  .left_menu_filter,
  .left_menu_title {
    font-size: 16px;
  }

  .left_menu_title {
    padding-bottom: 7px;
  }

  .flilterClass {
    font-size: 14px;
  }

  .yellownone,
  .yellow {
    height: 26px;
    padding: 4px 15px;
    line-height: 18px;
  }

  .yellow {
    border-radius: 7px;
  }

  .flilterClass {
    height: 30px;
    font-size: 14px;
    border-radius: 7px;
  }

  .Answerbutoon {
    font-size: 16px;
    border-radius: 7px;
    height: 30px;
    line-height: 30px;
    width: 250px;
  }

  .left_menu_question {
    margin-bottom: 15px;
    padding-bottom: 15px;
  }

  .leads_right_top_num {
    font-size: 12px;
    line-height: 32px;
    margin: 0 15px 10px;
  }

  .huanyipi {
    font-size: 16px;
  }

  .conpany-center-list {
    padding: 15px;
    margin-bottom: 7px;
  }

  .flex_center_between_box p,
  .conpany-center-list-left {
    font-size: 18px;
  }

  .flex_center_between_box p {
    margin-bottom: 7px;
  }

  .el-input--suffix .el-input__inner {
    padding-right: 20px;
  }

  .left_menu_bottom {
    font-size: 16px;
  }

  .left_menu_question /deep/ .el-tag.el-tag--info {
    font-size: 14px;
  }

  .icon {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }

  .icon-shoucang {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }

  .icontransform {
    font-size: 12px;
  }

  .list-text-color {
    font-size: 16px !important;
    line-height: 22px;
  }

  .list-text-color .single,
  .list-text-color span {
    margin-left: 7px;
  }

  .list-text-color img {
    width: 34px;
    height: 24px;
  }

  .iconbg {
    width: 38px;
    height: 38px;
  }

  .iconright {
    font-size: 20px;
  }

  .icontop {
    font-size: 18px;
  }

  .bottom-list-echarts {
    gap: 15px;
  }

  .bottom-list-echarts-li {
    padding: 15px 15px 7px;
    height: 240px;
  }

  .bottom-list-echarts-li-left {
    padding-right: 15px;
  }

  .bottom-list-echarts-li-right {
    padding-left: 15px;
  }

  .bottom-list-echarts-li-left-text {
    font-size: 14px;
    line-height: 30px;
    gap: 12px;
  }

  .color1290C9 {
    font-size: 14px;
  }

  .bottom-list-echarts-head {
    font-size: 16px !important;
  }

  .news-text {
    font-size: 14px;
    margin-bottom: 7px;
  }

  .bottom-list-echarts-li ul {
    padding-top: 7px;
  }

  .pb10 {
    padding-bottom: 7px;
  }

  .risk_right_box_header {
    margin: 0 15px;
    padding: 15px 0;
  }

  .risk_right_box {
    padding: 0 15px 15px;
  }

  .risk-right-content-title {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .risk_right_title {
    font-size: 18px;
  }

  .Upadetime {
    font-size: 16px;
    margin-right: 22px;
  }

  .risk-right-content {
    padding: 15px 0;
  }

  .MoreCompany {
    line-height: 20px;
  }

  .leads_cont_progress_txt,
  .right-txt,
  .left-txt {
    font-size: 16px;
  }

  .margin16 {
    margin-top: 12px;
  }

  .leads_cont_progress_pre >>> .el-progress__text,
  .leads_cont_progress_pre_sc >>> .el-progress__text {
    font-size: 14px;
  }

  .con_cen_list_right_btn {
    margin-top: 25px;
  }

  .leads_cont_progress_box {
    gap: 7px;
  }

  .Country_img {
    width: 24px;
    height: 14px;
    margin-right: 6px;
  }

  .Country_name {
    line-height: 16px;
    font-size: 14px;
  }

  .leads_cont_progress {
    border-radius: 7px;
  }

  .dialog_tip_img {
    width: 60px;
  }

  .clear_all {
    bottom: 5px;
    font-size: 14px;
  }

  .clear_all .iconfont {
    font-size: 13px;
    margin-right: 4px;
  }

  ::v-deep .el-table .el-table__header-wrapper .cell {
    font-size: 14px !important;
  }
  ::v-deep .el-input.is-disabled .el-input__inner,
  ::v-deep .el-input__inner {
    line-height: 30px;
  }
  .filter_first_checkbox {
    padding: 15px;
  }
  .filter_first_btn {
    width: 150px;
  }

  .icon_sanjiaoLocation {
    bottom: 15px;
    right: 15px;
  }
}

@media screen and (max-width: 1439px) {
  .modal-container {
    width: 510px;
  }

  .leads_cont_left {
    width: 300px;
    padding: 6px 6px 6px 12px;
  }

  .scrollbar_risk_right {
    width: calc(100% - 300px);
    padding: 10px 6px 6px;
  }

  .left_menu_question p {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .left_menu_filter,
  .left_menu_title {
    font-size: 14px;
  }

  .left_menu_title {
    padding-bottom: 6px;
  }

  .flilterClass {
    font-size: 12px;
  }

  .yellownone,
  .yellow {
    height: 24px;
    padding: 4px 10px;
    line-height: 16px;
  }

  .yellow {
    border-radius: 6px;
  }

  .flilterClass {
    height: 26px;
    font-size: 12px;
    border-radius: 6px;
  }

  .Answerbutoon {
    font-size: 14px;
    border-radius: 6px;
    height: 30px;
    line-height: 30px;
    width: 225px;
  }

  .left_menu_question {
    margin-bottom: 12px;
    padding-bottom: 12px;
  }

  .leads_right_top_num {
    font-size: 12px;
    line-height: 28px;
    margin: 0 12px 10px;
  }

  .huanyipi {
    font-size: 12px;
  }

  .conpany-center-list {
    padding: 12px;
    margin-bottom: 6px;
  }

  .flex_center_between_box p,
  .conpany-center-list-left {
    font-size: 16px;
  }

  .flex_center_between_box p {
    margin-bottom: 6px;
  }

  .el-input--suffix .el-input__inner {
    padding-right: 15px;
  }

  .left_menu_bottom {
    font-size: 14px;
  }

  .left_menu_question /deep/ .el-tag.el-tag--info {
    font-size: 12px;
  }

  .list-text-color {
    font-size: 14px !important;
    line-height: 20px;
  }

  .list-text-color .single,
  .list-text-color span {
    margin-left: 6px;
  }

  .list-text-color img {
    width: 30px;
    height: 21px;
  }

  .list-text-color .single {
    width: 55%;
  }

  .icon {
    width: 18px;
    height: 18px;
    font-size: 16px;
  }

  .iconbg {
    width: 34px;
    height: 34px;
  }

  .iconright {
    font-size: 18px;
  }

  .icontop {
    font-size: 16px;
  }
  .bottom-list-echarts {
    gap: 12px;
  }

  .bottom-list-echarts-li {
    padding: 12px 12px 6px;
  }

  .bottom-list-echarts-li-left {
    padding-right: 12px;
  }

  .bottom-list-echarts-li-right {
    padding-left: 12px;
  }

  .bottom-list-echarts-li-left-text {
    font-size: 12px;
    line-height: 26px;
    gap: 10px;
  }

  .color1290C9 {
    font-size: 12px;
  }

  .bottom-list-echarts-head {
    font-size: 14px !important;
  }

  .news-text {
    font-size: 12px;
    margin-bottom: 6px;
  }

  .bottom-list-echarts-li ul {
    padding-top: 6px;
  }

  .pb10 {
    padding-bottom: 6px;
  }

  .risk_right_box_header {
    margin: 0 12px;
    padding: 12px 0;
  }

  .risk_right_box {
    padding: 0 12px 12px;
  }

  .risk-right-content-title {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .risk_right_title {
    font-size: 16px;
  }

  .Upadetime {
    font-size: 14px;
    margin-right: 20px;
  }

  .risk-right-content {
    padding: 12px 0;
  }

  .MoreCompany {
    font-size: 12px;
    line-height: 16px;
  }

  .leads_cont_progress_txt,
  .right-txt,
  .left-txt {
    font-size: 14px;
  }

  .margin16 {
    margin-top: 10px;
  }

  .leads_cont_progress_pre >>> .el-progress__text,
  .leads_cont_progress_pre_sc >>> .el-progress__text {
    font-size: 14px;
  }

  .con_cen_list_right_btn {
    margin-top: 22px;
  }

  .leads_cont_progress_box {
    gap: 6px;
  }

  .leads_cont_progress {
    border-radius: 6px;
  }

  .dialog_tip_img {
    width: 54px;
  }

  ::v-deep .el-table .el-table__header-wrapper .cell {
    font-size: 14px !important;
  }
  ::v-deep .el-input.is-disabled .el-input__inner,
  ::v-deep .el-input__inner {
    line-height: 28px;
  }
  .filter_first_checkbox {
    padding: 12px;
    font-size: 14px;
    top: 30px;
  }
  .filter_first_btn {
    width: 120px;
  }

  .icon_sanjiaoLocation {
    bottom: 12px;
    right: 12px;
  }
}
</style>
